<div class="comparison-form" *ngIf="quotationList.length">
	<mat-stepper
		linear
		labelPosition="bottom"
		#stepper
		(selectionChange)="onStepChange($event)"
		[ngClass]="hideStepperLabel"
	>
		<!-- STEP 1 INSURERS -->
		<mat-step [stepControl]="quotationFrmGroup" state="edit">
			<form [formGroup]="quotationFrmGroup">
				<ng-template matStepLabel>
					<div>1.</div>
					{{ "comparison.step1" | translate }}
				</ng-template>

				<div fxLayoutGap="8px grid" class="mobile-details-btn-list">
					<div *ngIf="isVehicleTypeMotorcycle">
						<button mat-button (click)="carDetails()">
							<img src="assets/image/car-icon.png" alt="" />
							{{ "common.motorcycleDetails" | translate }}
						</button>
					</div>
					<div *ngIf="!isVehicleTypeMotorcycle">
						<button mat-button (click)="carDetails()">
							<img src="assets/image/car-icon.png" alt="" />
							{{ "common.carDetails" | translate }}
						</button>
					</div>

					<div>
						<button mat-button (click)="carPlan()">
							<img src="assets/image/shield-icon.png" alt="" />
							{{ "common.carProtectionPlan" | translate }}
						</button>
					</div>

					<div>
						<button mat-button (click)="editQuotation()">
							<img src="assets/image/edit.png" alt="" />
							{{ "common.quotation" | translate }}
						</button>
					</div>
				</div>


				<div class="insurance-providers">
					<mat-card class="border-card" *ngIf="!isVehicleTypeMotorcycle">
						<div style="padding: 8px">
							<div fxFlex.lt-md="100" fxFlex>
								<div class="heading" *ngIf="!isVehicleTypeMotorcycle">
									<img src="https://storage.googleapis.com/dev-ps-asset/Car_Insurance/icons/car-icon.png" alt="" />
									{{ "common.carDetails" | translate }}
								</div>
								<div class="heading" *ngIf="isVehicleTypeMotorcycle">
									<img src="https://storage.googleapis.com/ps-asset/motorcycle/shared/two-wheeler.png" alt="" />
									{{ "common.motorcycleDetails" | translate }}
								</div>
								<div class="car-info">
									<div class="label-desc" *ngIf="!isVehicleTypeMotorcycle">
										{{ "common.carNumber" | translate }}
									</div>
									<div class="label-desc" *ngIf="isVehicleTypeMotorcycle">
										{{ "common.motorcycleNumber" | translate }}
									</div>
									<div class="label-value">
										{{ requestData.vehicleNo || "-" }}
									</div>
								</div>
								<div class="car-info">
									<div class="label-desc" *ngIf="!isVehicleTypeMotorcycle">
										{{ "common.carModel" | translate }}
									</div>
									<div class="label-desc" *ngIf="isVehicleTypeMotorcycle">
										{{ "common.motorcycleModel" | translate }}
									</div>
									<div class="label-value">
										{{ requestData.make || "-" }}
									</div>
								</div>
							</div>

							<div fxFlex.lt-md="100" fxFlex>
								<div class="heading" *ngIf="!isVehicleTypeMotorcycle">
									<img src="https://storage.googleapis.com/dev-ps-asset/Car_Insurance/icons/shield-icon.png" alt="" />
									{{ "common.carProtectionPlan" | translate }}
								</div>
								<div class="heading" *ngIf="isVehicleTypeMotorcycle">
									<img src="https://storage.googleapis.com/dev-ps-asset/Car_Insurance/icons/shield-icon.png" alt="" />
									{{ "common.motorcycleProtectionPlan" | translate }}
								</div>
								<div class="car-info">
									<div class="label-desc" *ngIf="!isVehicleTypeMotorcycle">
										{{ "common.typeOfInsurance" | translate }} :
									</div>
									<div class="label-desc" *ngIf="isVehicleTypeMotorcycle">
										{{ "common.typeOfMotorcycleInsurance" | translate }} :
									</div>
									<div class="label-value">
										{{ "common." + requestData.insuranceType | translate }}
									</div>
								</div>
								<div class="car-info">
									<div class="label-desc">
										{{ "common.effectiveDate" | translate }}
									</div>
									<div class="label-value">
										{{ requestData.effectiveDate | date : "dd MMM yyyy" }}
									</div>
								</div>
							</div>
						</div>
						<button mat-stroked-button (click)="editQuotation()" class="default-btn" *ngIf="!isVehicleTypeMotorcycle">
							{{ "common.editQuotation" | translate }}
						</button>
					</mat-card>

					<mat-card
						class="quotation-validity no-elevation"
						fxLayout="row"
						fxLayoutAlign="center center"
						style="margin-bottom: 40px"
					>
						<img src="assets/icons/calendar-check.png" alt="" />
						<div class="smTitle-f color-purple ml-sm">
							{{ "comparison.quotationValidity" | translate }}
							{{ requestData?.expiredOn | date : "dd MMM yyyy" || "-" }}
						</div>
					</mat-card>

					<div style="padding: 14px 0">
						<div class="open-sans-heading">
							{{ "common.yourQuotationOptions" | translate }}
						</div>
						<div class="open-sans-subheading">
							{{ "common.yourQuotationOptions2" | translate }}
						</div>
					</div>

					<div *ngFor="let item of quotationListAvailable; let first = first">
						<app-insurer-card
							[item]="item"
							[first]="first"
							[requestData]="requestData"
							[insuranceType]="requestData?.insuranceType"
							[showTag]="requestData?.eHailingUsed"
							(onSubmit)="openCarVariantDialog(item?.id)"
						></app-insurer-card>
					</div>

					<ng-container *ngFor="let item of sortedQuotationList">
						<app-loading-insurer-card
							[insurer]="item"
							*ngIf="item?.status == 'New' || item?.status == 'Rejected'"
						></app-loading-insurer-card>
					</ng-container>

					<ng-container *ngIf="otherInsurerList.length && !this.isVehicleTypeMotorcycle">
						<div style="padding: 50px 0">
							<div class="open-sans-heading">
								{{ "common.exploreOtherInsurers" | translate }}
							</div>
							<div class="open-sans-subheading">
								{{ "common.exploreOtherInsurers2" | translate }}
							</div>
						</div>
						<div class="other-insurer-card-list">
							<app-other-insurer-card
								(clickEvent)="updateSelectedInsurers($event)"
								*ngFor="let x of otherInsurerList"
								[insurer]="x"
							></app-other-insurer-card>
						</div>
						<button
							mat-stroked-button
							class="default-btn"
							(click)="submitOtherInsurer()"
							style="margin-top: 30px"
						>
							{{ "comparison.getQuoteNow" | translate }}
						</button>
					</ng-container>
				</div>
			</form>
		</mat-step>

		<!-- STEP 2 ADD-ONS -->
		<mat-step
			[completed]="isStep2Valid"
			[state]="isStep2Valid ? 'edit' : 'close'"
		>
			<ng-template matStepLabel>
				<div>2.</div>
				{{ "comparison.step2" | translate }}
			</ng-template>

			<button mat-button matStepperPrevious class="step-back-btn">
				<mat-icon>arrow_back</mat-icon> {{ "common.back" | translate }}
			</button>

			<div fxLayout="row wrap" fxLayoutGap="16px grid">
				<div fxFlex.lt-md="100" fxFlex.gt-sm="60">
					<div class="section-container">
						<div class="title-sec">
							<div class="title-f" *ngIf="!isVehicleTypeMotorcycle">{{ "common.carDetails" | translate }}</div>
							<div class="title-f" *ngIf="isVehicleTypeMotorcycle">{{ "common.motorcycleDetails" | translate }}</div>
							<div class="divider"></div>
						</div>
						<div class="content-wrapper">
							<div class="left">
								<div class="label-desc" *ngIf="!isVehicleTypeMotorcycle">
									{{ "common.carNumber" | translate }} :
								</div>
								<div class="label-desc" *ngIf="isVehicleTypeMotorcycle">
									{{ "common.motorcycleNumber" | translate }} :
								</div>
							</div>
							<div class="right">
								<div class="label-value">{{ requestData.vehicleNo }}</div>
							</div>
							<div class="left">
								<div class="label-desc" *ngIf="!isVehicleTypeMotorcycle">
									{{ "common.carModel" | translate }} :
								</div>
								<div class="label-desc" *ngIf="isVehicleTypeMotorcycle">
									{{ "common.motorcycleModel" | translate }} :
								</div>
							</div>
							<div class="right">
								<div class="label-value">{{ requestData.vehicle }}</div>
							</div>
						</div>
					</div>

					<div class="section-container">
						<div class="title-sec">
							<div class="title-f" *ngIf="!isVehicleTypeMotorcycle">
								{{ "common.carProtectionPlan" | translate }}
							</div>
							<div class="title-f" *ngIf="isVehicleTypeMotorcycle">
								{{ "common.motorcycleProtectionPlan" | translate }}
							</div>
							<div class="divider"></div>
						</div>

						<div class="content-wrapper">
							<div class="left">
								<div class="label-desc" *ngIf="!isVehicleTypeMotorcycle">
									{{ "common.typeOfInsurance" | translate }} :
								</div>
								<div class="label-desc" *ngIf="isVehicleTypeMotorcycle">
									{{ "common.typeOfMotorcycleInsurance" | translate }} :
								</div>
							</div>
							<div class="right">
								<div class="label-value">
									{{ "common." + requestData.insuranceType | translate }}
								</div>
							</div>
							<div class="left">
								<div class="label-desc">
									{{ "common.insuranceProvider" | translate }} :
								</div>
							</div>
							<div class="right">
								<div class="label-value">{{ selectedQuotation?.name }}</div>
							</div>
							<div class="left">
								<div class="label-desc">
									{{ "common.sumInsured" | translate }} ({{
										"common." + selectedQuotation?.typeOfSum | translate
									}}) :
								</div>
							</div>
							<div class="right">
								<div class="label-value">
									RM {{ selectedQuotation?.sumInsured | number : "1.2-2" }}
								</div>
							</div>
							<div class="left">
								<div class="label-desc">
									{{ "common.effectivePeriod" | translate }} :
								</div>
							</div>
							<div class="right">
								<div class="label-value">
									{{ requestData.effectiveDate | date : "dd MMM yyyy" }}
								</div>
							</div>
						</div>
					</div>

					<button mat-stroked-button class="full-width" (click)="editQuotation()" *ngIf="!isVehicleTypeMotorcycle">
						{{ "common.editQuotation" | translate }}
					</button>

					<div class="section-container mt-sm">
						<div class="title-sec">
							<div class="title-f">{{ "addOn.addOns" | translate }}</div>
							<div class="divider"></div>
							<div class="desc">{{ "addOn.addOnsDesc" | translate }}</div>
						</div>
					</div>

					<ng-container *ngFor="let item of includeAddOnList">
						<ng-container *ngIf="item.code !== 'PersonalAccident' && item.category != 'UnlimitedTowing_Motorcycle'">
							<mat-card class="addon-card included selected">
								<div class="included-banner">
									{{ "addOn.included" | translate }}
									<mat-icon>check_circle </mat-icon>
								</div>
								<div *ngIf="item.code != 'CompanyDriver'">
									<div class="title">
										{{ "addOn." + item.code | translate }}
									</div>
									<div class="desc">
										{{ "addOn." + item.code + "Desc" | translate }}
									</div>
								</div>
								<div *ngIf="item.code == 'CompanyDriver'">
									<div fxLayout="row">
										<div fxFlex class="title">
											{{ "addOn." + item.code | translate }}
										</div>
										<div class="value selected">
											<span>RM</span> {{ getPrice(item) | number : "1.2-2" }}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="companyDriverTooltip"
											#companyDriverTrigger="matMenuTrigger"
											(mouseenter)="companyDriverTrigger.openMenu()"
										>
											info</mat-icon
										>
										<mat-menu
											#companyDriverTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="companyDriverTrigger.closeMenu()">
												{{ "addOn.UnlimitedTooltip" | translate }}
											</span>
										</mat-menu>
									</div>
									<div class="desc">
										<b>{{ "addOn.companyDriverCover" | translate }}</b>
										{{ "addOn.companyDriverCover2" | translate }}
										<b>RM {{ item.evaluate }}</b>.
									</div>
								</div>
							</mat-card>
						</ng-container>
						<ng-container *ngIf="item.category == 'UnlimitedTowing_Motorcycle' && isPAPlanGeneraliMotorcycleChecked">
							<mat-card class="addon-card included selected">
								<div class="included-banner">
									{{ "addOn.included" | translate }}
									<mat-icon>check_circle </mat-icon>
								</div>
								<div>
									<div class="title">
										{{ "addOn." + item.code | translate }}
									</div>
									<div class="desc">
										{{ "addOn." + item.code + "Desc" | translate }}
									</div>
								</div>
							</mat-card>
						</ng-container>
					</ng-container>

					<ng-container *ngTemplateOutlet="addOnFrom"> </ng-container>

					<div class="comparison-actions">
						<button mat-button matStepperPrevious class="back-btn">
							{{ "common.back" | translate }}
						</button>
						<button
							mat-button
							matStepperNext
							class="proceed-btn"
							[disabled]="step2DisableBtnCondition()"
						>
							{{ "common.proceed" | translate }}
						</button>
					</div>
				</div>

				<div fxFlex.lt-md="100" fxFlex.gt-sm="40">
					<mat-expansion-panel
						class="summary-card"
						hideToggle
						disabled
						#addon="matExpansionPanel"
						[expanded]="screenWidth > 960"
					>
						<mat-expansion-panel-header
							[collapsedHeight]="'100%'"
							[expandedHeight]="'100%'"
						>
							<button
								mat-icon-button
								class="expand-btn"
								(click)="addon.expanded = !addon.expanded"
								*ngIf="!addon.expanded"
							>
								<mat-icon>keyboard_arrow_up</mat-icon>
							</button>

							<div class="mobile-proceed-section">
								<div class="mobile-proceed-section__content">
									<p>
										<b>{{ "common.totalAmount" | translate }}</b>
									</p>
									<p class="value">
										<b>RM {{ getTotal() | number : "1.2-2" }}</b>
									</p>
								</div>

								<button
									mat-flat-button
									class="proceed-btn full-width"
									matStepperNext
									[disabled]="step2DisableBtnCondition()"
								>
									{{ "common.proceed" | translate }}
								</button>
							</div>
						</mat-expansion-panel-header>
						<button
							mat-icon-button
							class="expand-btn"
							(click)="addon.expanded = !addon.expanded"
							*ngIf="addon.expanded"
						>
							<mat-icon>keyboard_arrow_down</mat-icon>
						</button>
						<div class="expanded-content">
							<ng-container *ngTemplateOutlet="priceList"></ng-container>
						</div>
					</mat-expansion-panel>
					<ng-container *ngTemplateOutlet="printOrderSummary"></ng-container>

					<div
						class="expand-blackdrop"
						(click)="addon.expanded = !addon.expanded"
						*ngIf="addon.expanded"
					></div>
				</div>
			</div>
		</mat-step>

		<!-- STEP 3 PERSONAL INFO -->
		<mat-step
			[state]="infoFrmGroup.valid ? 'edit' : 'close'"
			[stepControl]="infoFrmGroup"
		>
			<ng-template matStepLabel>
				<div>3.</div>
				{{ "comparison.step3" | translate }}
			</ng-template>
			<button mat-button matStepperPrevious class="step-back-btn">
				<mat-icon>arrow_back</mat-icon> {{ "common.back" | translate }}
			</button>

			<div fxLayout="row wrap" fxLayoutGap="16px grid">
				<div fxFlex.lt-md="100" fxFlex.gt-sm="60">
					<ng-template *ngTemplateOutlet="personalInfoFrom"></ng-template>
					<div class="comparison-actions pt-md">
						<button mat-button matStepperPrevious class="back-btn">
							{{ "common.back" | translate }}
						</button>
						<button
							mat-button
							matStepperNext
							class="proceed-btn"
							[disabled]="getUserDetailsBtnCondition()"
						>
							{{ "common.proceed" | translate }}
						</button>
					</div>
				</div>
				<div fxFlex.lt-md="100" fxFlex.gt-sm="40">
					<mat-expansion-panel
						class="summary-card"
						hideToggle
						disabled
						#personal="matExpansionPanel"
						[expanded]="screenWidth > 960"
					>
						<mat-expansion-panel-header
							[collapsedHeight]="'100%'"
							[expandedHeight]="'100%'"
						>
							<button
								mat-icon-button
								class="expand-btn"
								(click)="personal.expanded = !personal.expanded"
								*ngIf="!personal.expanded"
							>
								<mat-icon>keyboard_arrow_up</mat-icon>
							</button>
							<div class="mobile-proceed-section">
								<div class="mobile-proceed-section__content">
									<p>
										<b>{{ "common.totalAmount" | translate }}</b>
									</p>
									<p class="value">
										<b>RM {{ getTotal() | number : "1.2-2" }}</b>
									</p>
								</div>
								<button
									mat-flat-button
									class="proceed-btn full-width"
									matStepperNext
									[disabled]="getUserDetailsBtnCondition()"
								>
									{{ "common.proceed" | translate }}
								</button>
							</div>
						</mat-expansion-panel-header>
						<button
							mat-icon-button
							class="expand-btn"
							(click)="personal.expanded = !personal.expanded"
							*ngIf="personal.expanded"
						>
							<mat-icon>keyboard_arrow_down</mat-icon>
						</button>
						<div class="expanded-content">
							<ng-container *ngTemplateOutlet="priceList"> </ng-container>
						</div>
					</mat-expansion-panel>
					<ng-container *ngTemplateOutlet="printOrderSummary"></ng-container>

					<div
						class="expand-blackdrop"
						(click)="personal.expanded = !personal.expanded"
						*ngIf="personal.expanded"
					></div>
				</div>
			</div>
		</mat-step>

		<!-- STEP 4 ORDER SUMMARY -->
		<mat-step
			[state]="agreementFrmGroup.valid ? 'edit' : 'close'"
			[stepControl]="agreementFrmGroup"
		>
			<ng-template matStepLabel>
				<div>4.</div>
				{{ "comparison.step4" | translate }}
			</ng-template>
			<button mat-button matStepperPrevious class="step-back-btn">
				<mat-icon>arrow_back</mat-icon> {{ "common.back" | translate }}
			</button>
			<div fxLayout="row wrap" fxLayoutGap="16px grid">
				<div fxFlex.lt-md="100" fxFlex.gt-sm="60">
					<div class="section-container mb-lg">
						<div class="title-sec">
							<div class="title-f">
								{{ "common.orderSummary" | translate }}
							</div>
							<div class="desc">
								{{ "common.orderSummaryDesc" | translate }}
							</div>
						</div>
					</div>
					<div class="mb-sm">
						<div fxLayout="row" class="mb-sm" fxLayoutAlign=" center">
							<div class="mdTitle-f" *ngIf="!isVehicleTypeMotorcycle">
								{{ "common.carProtectionPlan" | translate }}
							</div>
							<div class="mdTitle-f" *ngIf="isVehicleTypeMotorcycle">
								{{ "common.motorcycleProtectionPlan" | translate }}
							</div>
							<button mat-stroked-button class="edit-summary-btn" (click)="stepper.selectedIndex = 2">
								{{ "common.edit" | translate }}
							</button>
							<div class="summary-divider grey" fxFlex></div>
						</div>
						<div fxLayout="row" fxLayoutGap="16px grid">
							<div fxFlex="50">
								<mat-card>
									<img
										class="full-width"
										[src]="selectedQuotation?.image"
										alt=""
									/>
								</mat-card>
							</div>
							<div class="content-wrapper m-t-0" fxFlex="50">
								<div>
									<div class="label-desc">
										{{ "common.insuranceProvider" | translate }} :
									</div>
									<div class="label-value">
										{{ selectedQuotation?.name }}
									</div>
								</div>
								<div>
									<div class="label-desc" *ngIf="!isVehicleTypeMotorcycle">
										{{ "common.typeOfInsurance" | translate }} :
									</div>
									<div class="label-desc" *ngIf="isVehicleTypeMotorcycle">
										{{ "common.typeOfMotorcycleInsurance" | translate }} :
									</div>
									<div class="label-value">
										{{ "common." + requestData?.insuranceType | translate }}
									</div>
								</div>
								<div>
									<div class="label-desc">
										{{ "common.sumInsured" | translate }} ({{
											"common." + selectedQuotation?.typeOfSum | translate
										}}) :
									</div>
									<div class="label-value">
										RM {{ selectedQuotation?.sumInsured | number : "1.2-2" }}
									</div>
								</div>
								<div>
									<div class="label-desc">
										{{ "common.effectivePeriod" | translate }} :
									</div>
									<div class="label-value">
										{{ requestData.effectiveDate | date : "dd MMM yyyy" }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="mb-sm"
						*ngIf="
							addOnFrmGroup.value?.isIncludeRoadtax || selectedAddOn.length
						"
					>
						<div fxLayout="row" class="mb-sm" fxLayoutAlign=" center">
							<div class="mdTitle-f">{{ "addOn.addOns" | translate }}</div>
							<button
								mat-stroked-button
								class="edit-summary-btn"
								(click)="stepper.selectedIndex = 1"
							>
								{{ "common.edit" | translate }}
							</button>
							<div class="summary-divider grey" fxFlex></div>
						</div>
						<div class="add-ons-container">
							<div
								class="add-ons-cover"
								*ngIf="addOnFrmGroup.value?.isIncludeRoadtax"
							>
								{{ "addOn.roadTax" | translate }}
							</div>
							<div class="add-ons-cover" *ngFor="let item of selectedAddOn">
								{{ "addOn." + item.code | translate }}
							</div>
						</div>
					</div>
					<div class="mb-sm">
						<div fxLayout="row" class="mb-sm" fxLayoutAlign=" center">
							<div class="mdTitle-f" *ngIf ="!isVehicleTypeMotorcycle">
								{{ "common.carDetails" | translate }} :
							</div>
							<div class="mdTitle-f" *ngIf ="isVehicleTypeMotorcycle">
								{{ "common.motorcycleDetails" | translate }} :
							</div>
							<button mat-stroked-button class="edit-summary-btn" (click)="stepper.selectedIndex = 2">
								{{ "common.edit" | translate }}
							</button>
							<div class="summary-divider grey" fxFlex></div>
						</div>
						<div class="content-wrapper">
							<div class="left label-desc" *ngIf ="!isVehicleTypeMotorcycle">
								{{ "common.carNumber" | translate }} :
							</div>
							<div class="left label-desc" *ngIf ="isVehicleTypeMotorcycle">
								{{ "common.motorcycleNumber" | translate }} :
							</div>
							<div class="right label-value">
								{{ requestData?.vehicleNo }}
							</div>
							<div class="left label-desc" *ngIf ="!isVehicleTypeMotorcycle">
								{{ "common.carModel" | translate }} :
							</div>
							<div class="left label-desc" *ngIf ="isVehicleTypeMotorcycle">
								{{ "common.motorcycleModel" | translate }} :
							</div>
							<div class="right label-value">
								{{ requestData?.vehicle }}
							</div>
						</div>
					</div>
					<div class="mb-sm">
						<div fxLayout="row" class="mb-sm" fxLayoutAlign=" center">
							<div class="mdTitle-f">
								{{ "common.personalDetails" | translate }}
							</div>
							<button
								mat-stroked-button
								class="edit-summary-btn"
								(click)="stepper.selectedIndex = 2"
							>
								{{ "common.edit" | translate }}
							</button>
							<div class="summary-divider grey" fxFlex></div>
						</div>
						<div class="content-wrapper">
							<div class="label-desc left">
								{{ getNameLabel() | translate }}:
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.name || "-" }}
							</div>

							<ng-container *ngTemplateOutlet="personalDetail"> </ng-container>

							<div class="label-desc left">
								{{ "common.occupation" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.occupation }}
							</div>

							<div class="label-desc left">
								{{ "common.mobileNo" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.mobileNo }}
							</div>

							<div class="label-desc left">
								{{ "common.email" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.email }}
							</div>
						</div>
					</div>

					<div class="mb-sm">
						<div fxLayout="row" class="mb-sm" fxLayoutAlign=" center">
							<div class="mdTitle-f">
								{{ "common.residentialAddress" | translate }}
							</div>
							<button
								mat-stroked-button
								class="edit-summary-btn"
								(click)="stepper.selectedIndex = 2"
							>
								{{ "common.edit" | translate }}
							</button>
							<div class="summary-divider grey" fxFlex></div>
						</div>
						<div class="content-wrapper">
							<div class="label-desc left">
								{{ "common.addressLineOne" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.address }}
							</div>
							<div class="label-desc left">
								{{ "common.addressLineTwo" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.address2 }}
							</div>
							<div class="label-desc left">
								{{ "common.city" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.city }}
							</div>
							<div class="label-desc left">
								{{ "common.postcode" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.getRawValue().postcode }}
							</div>
							<div class="label-desc left">
								{{ "common.state" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.state }}
							</div>
						</div>
					</div>

					<div
						class="mb-sm"
						*ngIf="
							addOnFrmGroup.value?.isIncludeRoadtax && !isIncludeDigitalRoadtax
						"
					>
						<div fxLayout="row" class="mb-sm" fxLayoutAlign=" center">
							<div class="mdTitle-f">
								{{ "common.deliveryAddress" | translate }}
							</div>
							<button
								mat-stroked-button
								class="edit-summary-btn"
								(click)="stepper.selectedIndex = 2"
							>
								{{ "common.edit" | translate }}
							</button>
							<div class="summary-divider grey" fxFlex></div>
						</div>
						<div class="content-wrapper">
							<div class="label-desc left">
								{{ "common.addressLineOne" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.deliveryAddress }}
							</div>
							<div class="label-desc left">
								{{ "common.addressLineTwo" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.deliveryAddress2 }}
							</div>
							<div class="label-desc left">
								{{ "common.city" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.deliveryCity }}
							</div>
							<div class="label-desc left">
								{{ "common.postcode" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.deliveryPostcode }}
							</div>
							<div class="label-desc left">
								{{ "common.state" | translate }} :
							</div>
							<div class="label-value right">
								{{ infoFrmGroup.value.deliveryState }}
							</div>
						</div>
					</div>

					<ng-container
						*ngIf="requestData?.businessType === 'TransferOwnership' || requestData?.businessType === 'NewRegister'"
					>
						<div class="mb-sm">
							<div fxLayout="row" class="mb-sm" fxLayoutAlign=" center">
								<div class="mdTitle-f">
									{{ "common.financingDetails" | translate }}
								</div>
								<button
									mat-stroked-button
									class="edit-summary-btn"
									(click)="stepper.selectedIndex = 2"
								>
									{{ "common.edit" | translate }}
								</button>
								<div class="summary-divider grey" fxFlex></div>
							</div>
							<div class="content-wrapper">
								<div class="label-desc left">
									{{ "common.financingType" | translate }}:
								</div>
								<div class="label-value right">
									{{
										infoFrmGroup.value.financingType === "BankLoan"
											? "Bank loan"
											: "Cash"
									}}
								</div>
								<div class="label-desc left">Bank:</div>
								<div class="label-value right">
									{{ infoFrmGroup.value.bank || "-" }}
								</div>
								<div class="label-desc left">
									{{ "common.effectiveDate" | translate }}:
								</div>
								<div class="label-value right">
									{{ infoFrmGroup.value.effectiveDate | date : "dd MMM yyyy" }}
								</div>
							</div>
						</div>
					</ng-container>

					<ng-container
						*ngIf="
							requestData?.businessType === 'TransferOwnership' || requestData?.businessType === 'NewRegister' ||
							(requestData?.businessType === 'Renewal' &&
								hasSelectedCode('Flood')) ||
							(requestData?.businessType === 'Renewal' &&
								hasSelectedCode('Windshield'))
						"
					>
						<div class="mb-sm">
							<div fxLayout="row" class="mb-sm" fxLayoutAlign=" center">
								<div class="mdTitle-f">
									{{ "common.uploads" | translate }}
								</div>
								<button
									mat-stroked-button
									class="edit-summary-btn"
									(click)="stepper.selectedIndex = 2"
								>
									{{ "common.edit" | translate }}
								</button>
								<div class="summary-divider grey" fxFlex></div>
							</div>
							<div class="content-wrapper">
								<div class="label-desc left">
									{{ "common.uploadMykad" | translate }}:
								</div>
								<div class="label-value right">
									<div *ngFor="let item of mykadOrPassport">
										{{ item.name | truncate : [10, "..."] }}
									</div>
									<div *ngIf="!mykadOrPassport.length">-</div>
								</div>

								<ng-container
									*ngIf="requestData?.businessType === 'TransferOwnership' || requestData?.businessType === 'NewRegister'"
								>
									<div
										class="label-desc left"
										*ngIf="infoFrmGroup.value.financingType === 'BankLoan'"
									>
										{{ "common.uploadLOU" | translate }}
									</div>
									<div
										class="label-desc left"
										*ngIf="infoFrmGroup.value.financingType === 'Cash'"
									>
										{{ "common.uploadVSO" | translate }}
									</div>

									<div class="label-value right">
										<div *ngFor="let item of letterOfUndertaking">
											{{ item.name | truncate : [10, "..."] }}
										</div>
										<div *ngIf="!letterOfUndertaking.length">-</div>
									</div>
								</ng-container>

								<div class="label-desc left">
									{{ "common.uploadVehiclePhoto" | translate }}:
								</div>
								<div class="label-value right">
									<div *ngFor="let item of vehiclePhoto">
										{{ item.name | truncate : [10, "..."] }}
									</div>
									<div *ngIf="!vehiclePhoto.length">-</div>
								</div>

								<ng-container *ngIf="hasSelectedCode('Flood')">
									<div class="label-desc left">
										{{ "common.uploadVehiclePhoto" | translate }}:
									</div>
									<div class="label-value right">
										<div *ngFor="let item of vehicleInteriorPhoto">
											{{ item.name | truncate : [10, "..."] }}
										</div>
										<div *ngIf="!vehicleInteriorPhoto.length">-</div>
									</div>
								</ng-container>

								<ng-container *ngIf="hasSelectedCode('Flood')">
									<div class="label-desc left">
										{{ "common.uploadVehicleVideo" | translate }}:
									</div>
									<div class="label-value right">
										<div *ngFor="let item of vehicleVideo">
											{{ item.name | truncate : [10, "..."] }}
										</div>
										<div *ngIf="!vehicleVideo.length">-</div>
									</div>
								</ng-container>
							</div>
						</div>
					</ng-container>

					<!-- MOBILE ONLY EPP & ORDER SUMMARY & SUBMIT ACTIONS -->
					<ng-container
						*ngIf="stepper.selectedIndex == 3 && screenWidth <= 960"
					>
						<div class="mb-sm" *ngIf="!isVehicleTypeMotorcycle">
							<div fxLayout="row" class="mb-sm" fxLayoutAlign=" center">
								<div class="mdTitle-f">
									{{ "common.paymentOption" | translate }}
								</div>
								<div class="summary-divider grey" fxFlex></div>
							</div>
							<app-payment-options
								[paymentData]="paymentData"
								[paymentValues]="getPaymentValues()"
								(selectedPaymentData)="updatePaymentType($event)"
								[request]="this.requestData"
								[promo]="this.promo"
								#paymentOption
							></app-payment-options>
						</div>

						<div class="mb-sm">
							<ng-container *ngTemplateOutlet="priceList"></ng-container>
						</div>

						<div class="mb-sm">
							<form [formGroup]="agreementFrmGroup">
								<div class="multi-checkbox-section">
									<section>
										<mat-checkbox formControlName="agreeInfo"
											>{{ "common.confirmationOne" | translate }}
										</mat-checkbox>
									</section>

									<section formArrayName="doc">
										<ng-container
											*ngFor="
												let item of getAgreeFormArray()?.controls;
												let i = index
											"
										>
											<ng-container [formGroupName]="i">
												<mat-checkbox formControlName="checked"
													>{{ "common.confirmationTwo" | translate
													}}<b> {{ selectedQuotation?.name }} </b
													><a
														[href]="getAgreeFormArray()?.controls[i].value?.url"
														target="blank"
														>{{
															getAgreeFormArray()?.controls[i].value?.name
														}}</a
													>.
												</mat-checkbox>
											</ng-container>
										</ng-container>
									</section>

									<section>
										<mat-checkbox formControlName="marketingConsent">
											{{ "common.allianzMarketingConsent" | translate }}
										</mat-checkbox>
									</section>
								</div>
							</form>

							<div class="order-summmary__actions">
								<button
									mat-flat-button
									(click)="submit()"
									class="full-width payment-btn"
									[disabled]="
										agreementFrmGroup.invalid || !paymentData?.formIsValid
									"
								>
									{{ "paymentOptions.readyToPay" | translate }}
								</button>
								<button
									mat-stroked-button
									(click)="saveOrder()"
									class="full-width"
								>
									{{ "comparison.saveDraft" | translate }}
								</button>
								<button mat-stroked-button (click)="print()" class="full-width">
									{{ "comparison.generateOrderSummary" | translate }}
								</button>
							</div>
						</div>
					</ng-container>
				</div>

				<div fxFlex.lt-md="100" fxFlex.gt-sm="40">
					<mat-expansion-panel
						class="summary-card"
						hideToggle
						disabled
						#summary="matExpansionPanel"
						[expanded]="screenWidth > 960"
					>
						<!-- MOBILE VIEW ONLY -->
						<mat-expansion-panel-header
							*ngIf="screenWidth < 960 && stepper.selectedIndex == 3"
							[collapsedHeight]="'100%'"
							[expandedHeight]="'100%'"
						>
							<div class="mobile-proceed-section">
								<div class="mobile-proceed-section__content">
									<p>
										<b>{{ "common.totalAmount" | translate }}</b>
									</p>
									<div class="values-section">
										<p class="value">
											<b>RM {{ getTotal() | number : "1.2-2" }}</b>
										</p>
										<ng-container *ngIf="getInstallmentDetails()">
											<p>
												<b>
													<span>RM </span>
													<span>{{
														getInstallmentDetails().installmentAmount
															| number : "1.2-2"
													}}</span>
												</b>
												<span> {{ "common.perMonth" | translate }}</span>
											</p>
											<p>
												{{
													getInstallmentDetails().installmentMonths | translate
												}}
											</p>
										</ng-container>
									</div>
								</div>
							</div>
						</mat-expansion-panel-header>

						<!-- DESKTOP VIEW ONLY -->
						<ng-container
							*ngIf="screenWidth > 960 && stepper.selectedIndex == 3"
						>
							<button
								mat-icon-button
								class="expand-btn"
								(click)="summary.expanded = !summary.expanded"
								*ngIf="summary.expanded && !isVehicleTypeMotorcycle"
								
							>
								<mat-icon>keyboard_arrow_down</mat-icon>
							</button>
							<div class="expanded-content">
								<ng-container *ngTemplateOutlet="priceList"> </ng-container>

								<div *ngIf="!isVehicleTypeMotorcycle">
									<app-payment-options
										[paymentValues]="getPaymentValues()"
										[paymentData]="paymentData"
										[isApplyDraft]="isApplyDraft"
										(selectedPaymentData)="updatePaymentType($event)"
										[request]="this.requestData"
										[promo]="this.promo"
										#paymentOption
									></app-payment-options>
								</div>
							

								<form [formGroup]="agreementFrmGroup">
									<div class="multi-checkbox-section">
										<section>
											<mat-checkbox formControlName="agreeInfo"
												>{{ "common.confirmationOne" | translate }}
											</mat-checkbox>
										</section>

										<section formArrayName="doc">
											<ng-container
												*ngFor="
													let item of getAgreeFormArray()?.controls;
													let i = index
												"
											>
												<ng-container [formGroupName]="i">
													<mat-checkbox formControlName="checked"
														>{{ "common.confirmationTwo" | translate
														}}<b> {{ selectedQuotation?.name }} </b
														><a
															[href]="
																getAgreeFormArray()?.controls[i].value?.url
															"
															target="blank"
															>{{
																getAgreeFormArray()?.controls[i].value?.name
															}}</a
														>.
													</mat-checkbox>
												</ng-container>
											</ng-container>
										</section>

										
										<section *ngIf="isAllianzQuotation">
											<mat-checkbox formControlName="marketingConsent">
												{{ "common.allianzMarketingConsent" | translate }}
											</mat-checkbox>
										</section>
									</div>
								</form>

								<div class="order-summmary__actions">
									<button
										mat-stroked-button
										class="full-width"
										(click)="getLinkToCustomer()"
									>
										{{ "comparison.copyLinkToCustomer" | translate }}
									</button>
									<button
										mat-flat-button
										(click)="submit()"
										class="full-width payment-btn"
										[disabled]="
											agreementFrmGroup.invalid || !paymentData?.formIsValid
										"
									>
										{{ "paymentOptions.readyToPay" | translate }}
									</button>
									<button
										mat-stroked-button
										(click)="saveOrder()"
										class="full-width"
									>
										{{ "comparison.saveDraft" | translate }}
									</button>
									<button
										mat-stroked-button
										(click)="print()"
										class="full-width"
									>
										{{ "comparison.generateOrderSummary" | translate }}
									</button>
								</div>
							</div>
						</ng-container>
					</mat-expansion-panel>

					<div
						class="expand-blackdrop"
						(click)="summary.expanded = !summary.expanded"
						*ngIf="summary.expanded"
					></div>
				</div>
			</div>
		</mat-step>

		<!-- STEPPER ICONS -->
		<ng-template matStepperIcon="edit">
			<mat-icon>edit</mat-icon>
		</ng-template>

		<ng-template matStepperIcon="close">
			<mat-icon>close</mat-icon>
		</ng-template>
	</mat-stepper>
</div>

<ng-template #priceList>
	<div class="price-list__insurer-logo">
		<img [src]="selectedQuotation?.image" class="selected-insurer" alt="" />
	</div>

	<div
		class="expansion-container"
		(click)="benefitsExpanded = !benefitsExpanded"
	>
		<div class="expansion-container__flex">
			<div>
				{{ "common.benefits" | translate }}
			</div>
			<mat-icon *ngIf="benefitsExpanded">keyboard_arrow_up</mat-icon>
			<mat-icon *ngIf="!benefitsExpanded">keyboard_arrow_down</mat-icon>
		</div>
		<div *ngIf="benefitsExpanded">
			<app-benefit [code]="selectedQuotation?.code" [insuranceType]="requestData?.insuranceType" [vehicleType]="requestData?.vehicleType"></app-benefit>
		</div>
	</div>

	<div class="content-wrapper">
		<div class="left">
			<div class="label-desc">
				{{ "common.sumInsured" | translate }} (SI) ({{
					"common." + selectedQuotation?.typeOfSum | translate
				}})
			</div>
		</div>
		<div class="right">
			<div class="label-value text-right">
				RM {{ selectedQuotation?.sumInsured | number : "1.2-2" }}
			</div>
		</div>
		<div class="left">
			<div class="label-desc">{{ "common.basePremium" | translate }}</div>
		</div>
		<div class="right">
			<div class="label-value text-right">
				RM {{ selectedQuotation?.basePremium | number : "1.2-2" }}
			</div>
		</div>
		<div class="left">
			<div class="label-desc">
				{{ "common.noClaimDiscount" | translate }} <br />
				<b>({{ requestData?.ncd * 100 | number : "1.0-2" }}%)</b>
			</div>
		</div>
		<div class="right">
			<div class="label-value text-right color-red">
				- RM
				{{
					selectedQuotation?.basePremium - selectedQuotation?.totalBasePremium
						| number : "1.2-2"
				}}
			</div>
		</div>
	</div>
	<mat-divider></mat-divider>
	<div class="content-wrapper">
		<div class="left">
			<div class="label-desc">
				{{ "common.totalBasePremium" | translate }}
			</div>
		</div>
		<div class="right">
			<div class="label-value text-right">
				RM {{ selectedQuotation?.totalBasePremium | number : "1.2-2" }}
			</div>
		</div>

		<div *ngIf="hasAddOn()">
			<span class="quotation-cover-label">{{
				"addOn.addOnsCapital" | translate
			}}</span>
		</div>

		<ng-container *ngFor="let item of selectedAddOn">
			<ng-container *ngIf="!item.hidePriceBreakdown && item.isIncludeSST">
				<div class="left">
					<div class="label-desc">
						{{ "addOn." + (item.code === 'UnlimitedDrivers' && isChubbIQ ? item.code + 'Chubb' : item.code) | translate }}
					</div>
				</div>
				<div class="right">
					<ng-container [ngSwitch]="item.code">
						<ng-container *ngSwitchCase="'Windshield'">
							<div class="text-right">
								RM
								{{
									getPrice(item, addOnFrmGroup.value.windshield)
										| number : "1.2-2"
								}}
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="'AdditionalDrivers'">
							<div class="text-right">
								RM
								{{
									getPrice(item, getFormArray()?.controls.length)
										| number : "1.2-2"
								}}
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="'FGAP'">
							<div class="text-right">
								RM
								{{ addOnFrmGroup.value.fgap | number : "1.2-2" }}
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="'LLTP'">
							<div
								class="text-right"
								[title]="'addOn.' + item.code | translate"
							>
								RM
								{{ getPrice(item, this.numberOfLltpSeats) | number : "1.2-2" }}
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="'GCKT'">
							<div
								class="text-right"
								[title]="'addOn.' + item.code | translate"
							>
								RM
								{{
									getPrice(item, addOnFrmGroup.value.gckt) | number : "1.2-2"
								}}
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="'VA'">
							<div
								class="text-right"
								[title]="'addOn.' + item.code | translate"
							>
								RM
								{{ getPrice(item, addOnFrmGroup.value.va) | number : "1.2-2" }}
							</div>
						</ng-container>
						<ng-container *ngSwitchCase="'UnlimitedDrivers'">
							<div *ngIf = "item.customCode === 'Generali_UnlimitedDrivers'"
								class="text-right"
								[title]="'addOn.' + item.code | translate"
							>
								RM
								{{ getPrice(item, +item.evaluate) | number : "1.2-2" }}
							</div>
							<div *ngIf = "item.customCode !== 'Generali_UnlimitedDrivers'"
								class="text-right"
								[title]="'addOn.' + item.code | translate"
							>
								RM {{ getPrice(item) | number : "1.2-2" }}
							</div>
						</ng-container>
						<ng-container *ngSwitchDefault>
							<div class="text-right">
								RM {{ getPrice(item) | number : "1.2-2" }}
							</div>
						</ng-container>
					</ng-container>
				</div>
			</ng-container>
		</ng-container>
	</div>
	<mat-divider></mat-divider>

	<div class="content-wrapper">
		<div class="left">
			<div class="label-desc">
				{{ "common.totalGrossPremium" | translate }}
			</div>
		</div>
		<div class="right">
			<div class="label-value text-right">
				RM {{ getPaymentValues().grossPremium | number : "1.2-2" }}
			</div>
		</div>
		<div class="left">
			<div class="label-desc">
				{{ "common.serviceTax" | translate }} ({{
					selectedQuotation?.taxRate * 100 | number : "1.0-2"
				}}%)
			</div>
		</div>
		<div class="right">
			<div class="text-right">
				RM {{ getPaymentValues().taxAmount | number : "1.2-2" }}
			</div>
		</div>

		<div class="left">
			<div class="label-desc">{{ "common.stampDuty" | translate }}</div>
		</div>
		<div class="right">
			<div class="text-right">
				RM {{ selectedQuotation?.stampDutyPrice | number : "1.2-2" }}
			</div>
		</div>
	</div>
	<mat-divider></mat-divider>

	<div class="content-wrapper">
		<div class="left">
			<div class="label-desc">{{ "common.totalNetPremium" | translate }}</div>
		</div>
		<div class="right">
			<div class="label-value text-right">
				RM {{ getPaymentValues().totalNetPremium | number : "1.2-2" }}
			</div>
		</div>
		<ng-container *ngIf="selectedQuotation?.platformDiscountRate !== 0">
			<div class="left">
				<div class="label-desc">{{ "common.platformOffer" | translate }}</div>
			</div>
			<div class="right">
				<div class="label-value text-right color-red">
					- RM
					{{ getPaymentValues().platformDiscountRateAmount | number : "1.2-2" }}
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="addOnFrmGroup.value?.isIncludeRoadtax">
			<div class="left">
				<div class="label-desc">{{ "addOn.roadTax" | translate }}</div>
			</div>
			<div class="right">
				<div class="text-right">
					RM {{ requestData.roadTaxPrice | number : "1.2-2" }}
				</div>
			</div>
			<ng-container *ngIf="!isIncludeDigitalRoadtax">
				<div class="left">
					<div class="label-desc">
						{{ "addOn.roadTaxDelivery" | translate }}
					</div>
				</div>
				<div class="right">
					<div class="text-right">
						RM {{ requestData.roadTaxDeliveryPrice | number : "1.2-2" }}
					</div>
				</div>
			</ng-container>
		</ng-container>

    <!-- Non SST Addons -->
		<ng-container *ngIf="selectedNonSSTAddOnToDisplay.length">
			<ng-container *ngFor="let item of selectedNonSSTAddOnToDisplay">
				<div class="left">
					<div class="label-desc">{{ "addOn." + item.customCode | translate }}</div>
				</div>
				<div class="right">
					<div class="text-right">
						RM {{ getPrice(item, this.numberOfLltpSeats) | number : '1.2-2' }}
					</div>
				</div>
			</ng-container>
		</ng-container>
	</div>

	<mat-divider></mat-divider>

	<div class="content-wrapper">
		<div class="left">
			<div class="label-desc">{{ "common.totalCharges" | translate }}</div>
		</div>
		<div class="right">
			<div class="label-value text-right">
				RM {{ getPaymentValues().totalCharge | number : "1.2-2" }}
			</div>
		</div>

		<ng-container *ngIf="promo">
			<div class="left">
				<div class="label-desc">{{ promo.name }}</div>
			</div>
			<div class="right">
				<div class="label-value text-right color-red">
					- RM {{ getPaymentValues().totalPromo | number : "1.2-2" }}
				</div>
			</div>
		</ng-container>

		<ng-container *ngIf="selectedQuotation?.serviceTaxRate !== 0">
			<div class="left">
				<div class="label-desc">{{ "common.serviceFee" | translate }}</div>
			</div>
			<div class="right">
				<div class="text-right">
					RM {{ getPaymentValues().serviceFee | number : "1.2-2" }}
				</div>
			</div>
		</ng-container>

		<!-- <ng-container *ngIf="paymentData.paymentType === paymentOptionShopback">
			<div class="left">
				<div class="label-desc">
					{{ "paymentOptions.installmentCharges" | translate }}
				</div>
			</div>
			<div class="right">
				<div class="text-right">
					RM {{ getPaymentValues().shopbackFee | number : "1.2-2" }}
				</div>
			</div>
		</ng-container> -->

		<ng-container
			*ngIf="
				paymentData.paymentType === paymentOptionEpp && getInstallmentDetails()
			"
		>
			<div class="left">
				<div class="label-desc">
					{{ "paymentOptions.bankInstallmentCharges" | translate }}
				</div>
			</div>
			<div class="right installment">
				<div
					class="zero-instalment"
					*ngIf="getPaymentValues().bankInstallmentFee == 0"
				>
					{{ "common.zeroInstalment" | translate }}
				</div>
				<div class="text-right installment-fee">
					RM {{ getPaymentValues().bankInstallmentFee | number : "1.2-2" }}
				</div>
			</div>
		</ng-container>

		<!-- BNPL Charges -->
		<ng-container *ngIf="paymentData.paymentType === paymentOptionBNPL">
			<div class="left">
				<div class="label-desc">{{ "paymentOptions.bnplCharges" | translate }}</div>
			</div>
			<div class="right installment">
				<div class="zero-instalment" *ngIf="getPaymentValues().bnplServiceFee == 0">
					{{ "common.bnplSubsidized" | translate }}
				</div>
				<div class="text-right installment-fee">
					RM {{ getPaymentValues().bnplServiceFee | number : "1.2-2" }}
				</div>
			</div>
		</ng-container>

	</div>
	<mat-divider></mat-divider>

	<div class="content-wrapper">
		<div class="left">
			<div class="label-desc">{{ "common.totalAmount" | translate }}</div>
		</div>
		<div class="right">
			<div class="label-value text-right" style="color: #24a148">
				RM {{ getTotal() | number : "1.2-2" }}
			</div>
			<ng-container *ngIf="getInstallmentDetails()">
				<div class="text-right mt-sm">
					<b>
						<span>RM </span>
						<span>{{
							getInstallmentDetails().installmentAmount | number : "1.2-2"
						}}</span>
					</b>
					<span> {{ "common.perMonth" | translate }}</span>

					<span>
						{{ getInstallmentDetails().installmentMonths | translate }}
					</span>
				</div>
			</ng-container>
		</div>
		<div class="left"></div>
	</div>
	<ng-container *ngTemplateOutlet="promoTemplate"></ng-container>
</ng-template>

<ng-template #personalDetail>
	<div class="label-desc left">{{ getIdentityNoLabel() | translate }} :</div>
	<div class="label-value right">
		{{ requestData?.identityNo }}
	</div>

	<ng-container *ngIf="!requestData?.isCompany">
		<ng-container *ngIf="requestData?.isMalaysian">
			<ng-container *ngIf="requestData?.policIdentityNo">
				<div class="label-desc left">
					{{ "common.policeOrArmyIcNo" | translate }} :
				</div>
				<div class="label-value right">
					{{ requestData?.policIdentityNo || "-" }}
				</div>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="!requestData?.isMalaysian">
			<div class="label-desc left">
				{{ "common.nationality" | translate }} :
			</div>
			<div class="label-value right">
				{{ requestData?.nationality }}
			</div>
		</ng-container>

		<div class="label-desc left">{{ "common.gender" | translate }} :</div>
		<div class="label-value right">
			{{ "common." + requestData.gender | translate }}
		</div>
		<div class="label-desc left">
			{{ "common.maritalStatus" | translate }} :
		</div>
		<div class="label-value right">
			{{ "common." + requestData.maritalStatus | translate }}
		</div>

		<div class="label-desc left">{{ "common.dob" | translate }} :</div>
		<div class="label-value right">
			{{ requestData?.dob | date : "dd MMM yyyy" }}
		</div>
	</ng-container>
</ng-template>

<ng-template #promoTemplate>
	<div class="promo-input pt-sm pb-sm" (click)="$event.stopPropagation()">
		<div class="flex">
			<mat-form-field appearance="outline" class="promo-btn">
				<input
					matInput
					[placeholder]="'common.enterPromoCode' | translate"
					[(ngModel)]="promoCode"
					[readonly]="promo != null"
					autocomplete="off"
					(click)="$event.stopPropagation()"
					[ngModelOptions]="{ standalone: true }"
				/>
				<div class="floating-btn">
					<button
						type="button"
						mat-icon-button
						matSuffix
						(click)="$event.stopPropagation(); clearPromoCode()"
						*ngIf="promoCode"
					>
						<mat-icon class="color-secondary">cancel</mat-icon>
					</button>

					<!-- <button type="button" mat-icon-button matSuffix *ngIf="promo && promoCode">
						<mat-icon class="color-green">check_circle</mat-icon>
					</button> -->
				</div>
				<button
					type="button"
					mat-flat-button
					matSuffix
					(click)="$event.stopPropagation(); applyPromoCode()"
					*ngIf="!promo || !promoCode"
				>
					{{ "common.apply" | translate }}
				</button>

				<button
					type="button"
					mat-flat-button
					matSuffix
					(click)="$event.stopPropagation(); applyPromoCode()"
					*ngIf="promo && promoCode"
				>
					{{ "common.applied" | translate }}
				</button>
			</mat-form-field>
		</div>
		<div class="promo-error" *ngIf="promoError">
			{{ "common." + promoError | translate : { promoMinAmt: promoMinAmount | number : "1.2-2", promoMaxAmt: promoMaxAmount | number : "1.2-2" } }}
		</div>
		<div class="promo-valid" *ngIf="promo && promoCode">
			<mat-icon class="color-green mr-xs">check_circle</mat-icon> Promo code
			applied.
		</div>
	</div>
</ng-template>

<ng-template #printOrderSummary>
	<div class="generate-order-summary" (click)="print()">
		{{ "comparison.generateOrderSummary" | translate }}
	</div>

	<iframe id="iframePrint" style="display: none">
		<div id="printOrderSummary">
			<div class="summary-main-container">
				<div fxLayout="row" fxLayoutAlign="end">
					<img src="{{ getPartnerLogo() }}" alt="logo" style="width: 350px" />
				</div>

				<div fxLayout="row" fxLayoutAlign="space-between center">
					<h2>{{ "comparison.quotationSummary" | translate }}</h2>
					<span>{{currentDate | date: 'dd MMM yyyy'}}</span>
				</div>

				<b class="summary-info-header">{{ "comparison.customerInformation" | translate }}</b>
				<div class="summary-info-container">
					<div fxLayout="row" fxLayoutAlign="space-between">
						<div>{{ "common.name" | translate }}</div>
						<b>{{ infoFrmGroup.controls["name"].value || "-" }}</b>
					</div>

					<div fxLayout="row" fxLayoutAlign="space-between">
						<div>{{ "common.icNo" | translate }}</div>
						<b>{{ requestData?.identityNo }}</b>
					</div>

					<ng-container
						*ngIf="
							!requestData?.isCompany &&
							requestData?.isMalaysian &&
							requestData?.policIdentityNo
						"
					>
						<div fxLayout="row" fxLayoutAlign="space-between">
							<div>{{ "common.policeOrArmyIcNo" | translate }}</div>
							<b>{{ requestData?.policIdentityNo || "-" }}</b>
						</div>
					</ng-container>

					<div fxLayout="row" fxLayoutAlign="space-between">
						<div>{{ "common.carPlateNo" | translate }}</div>
						<b>{{ requestData?.vehicleNo || "-" }}</b>
					</div>
				</div>

				<b class="summary-info-header">{{ "comparison.carDetails" | translate }}</b>
				<div class="summary-info-container">
					<div fxLayout="row" fxLayoutAlign="space-between">
						<div>{{ "comparison.brand" | translate }}</div>
						<b>{{ requestData.make }}</b>
					</div>

					<div fxLayout="row" fxLayoutAlign="space-between">
						<div>{{ "comparison.model" | translate }}</div>
						<b>{{ requestData.model }}</b>
					</div>

					<div fxLayout="row" fxLayoutAlign="space-between">
						<div>{{ "comparison.variant" | translate }}</div>
						<b>{{ requestData.variant }}</b>
					</div>
				</div>

				<b class="summary-info-header">{{ "comparison.orderDetails" | translate }}</b>
				<div class="summary-info-container">
					<div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 5px;">
						<div>{{ "comparison.insuranceProvider" | translate }}</div>
						<img [src]="selectedQuotation?.image" alt="" style="width: 80px" />
					</div>

					<div fxLayout="row" fxLayoutAlign="space-between">
						<div>{{ "comparison.coverageType" | translate }}</div>
						<b>{{ "common." + requestData.insuranceType | translate }}</b>
					</div>

					<div fxLayout="row" fxLayoutAlign="space-between">
						<div>{{ "comparison.addOn" | translate }}</div>
						<b *ngIf="selectedAddOn.length == 0">N/A</b>
					</div>

					<div fxLayout="column" fxLayoutAlign="space-between">
						<div *ngFor="let item of selectedAddOn">
							<div *ngIf="!item.hidePriceBreakdown" >
								<ul fxLayout="row" fxLayoutAlign="space-between" style="margin: 0;">
									<li>
										<ng-container *ngIf="item.customCode != 'UnlimitedTowing_PA'">
											{{ "addOn." + item.code | translate }}

											<span *ngIf="item.code == 'Windshield'">
												(SI: <b>RM {{ addOnFrmGroup.value.windshield }}</b>)
											</span>
										</ng-container>

										<ng-container *ngIf="item.customCode == 'UnlimitedTowing_PA'">
											{{ "addOn." + item.customCode | translate }}
										</ng-container>

										<ng-container *ngIf="item.customCode == 'IMOTORBIKE' && item.code">
											{{ "addOn." + item.code | translate }}
										</ng-container>

										<ng-container *ngIf="!item.isIncludeSST">
											*
										</ng-container>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<b class="summary-info-header">{{ "comparison.paymentDetails" | translate }}</b>
				<div class="summary-info-container">
					<div fxLayout="row" fxLayoutAlign="space-between">
						<div fxFlex="75">
							{{ "common.sumInsured" | translate }} (SI) ({{
								"common." + selectedQuotation?.typeOfSum | translate
							}})
						</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ selectedQuotation?.sumInsured | number : "1.2-2" }}
						</div>
					</div>

					<div fxLayout="row" fxLayoutAlign="space-between">
						<div fxFlex="75">{{ "common.basePremium" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ selectedQuotation?.basePremium | number : "1.2-2" }}
						</div>
					</div>

					<div fxLayout="row" fxLayoutAlign="space-between">
						<div fxFlex="75">
							{{ "common.noClaimDiscount" | translate }} ({{
								requestData?.ncd * 100 | number : "1.0-2"
							}}%)
						</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							-
							{{
								selectedQuotation?.basePremium -
									selectedQuotation?.totalBasePremium | number : "1.2-2"
							}}
						</div>
					</div>

					<div
						fxLayout="row"
						fxLayoutAlign="space-between"
						style="
							font-weight: bold;
							margin: 10px 0px;
							background-color: #f4f6faff;
						"
					>
						<div fxFlex="75">{{ "common.totalBasePremium" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ selectedQuotation?.totalBasePremium | number : "1.2-2" }}
						</div>
					</div>

					<!-- Normal Add On List -->
					<ng-container *ngFor="let item of selectedAddOn">
						<ng-container *ngIf="item.isIncludeSST && !item.hidePriceBreakdown">
							<div fxLayout="row" fxLayoutAlign="space-between">
								<div fxFlex="75">
									Add On: {{ "addOn." + item.code | translate }}
									<span *ngIf="item.code == 'Windshield'">
										(SI: <b>RM {{ addOnFrmGroup.value.windshield }}</b>)
									</span>
								</div>
								<div fxFlex="10" fxLayoutAlign="end">RM</div>

								<ng-container [ngSwitch]="item.code">
									<ng-container *ngSwitchCase="'Windshield'">
										<div fxFlex="15" fxLayoutAlign="end">
											{{
												getPrice(item, addOnFrmGroup.value.windshield)
													| number : "1.2-2"
											}}
										</div>
									</ng-container>

									<ng-container *ngSwitchCase="'AdditionalDrivers'">
										<div fxFlex="15" fxLayoutAlign="end">
											{{
												getPrice(item, getFormArray()?.controls.length)
													| number : "1.2-2"
											}}
										</div>
									</ng-container>

									<ng-container *ngSwitchCase="'UnlimitedDrivers'">
										<div *ngIf="item.customCode === 'Generali_UnlimitedDrivers'">
											<div fxFlex="15" fxLayoutAlign="end">
												{{ getPrice(item, +item.evaluate) | number : "1.2-2" }}
											</div>
										</div>
										<div *ngIf="item.customCode !== 'Generali_UnlimitedDrivers'">
											<div fxFlex="15" fxLayoutAlign="end">
												{{ getPrice(item) | number : "1.2-2" }}
											</div>
										</div>
									</ng-container>

									<ng-container *ngSwitchCase="'FGAP'">
										<div fxFlex="15" fxLayoutAlign="end">
											{{ addOnFrmGroup.value.fgap | number : "1.2-2" }}
										</div>
									</ng-container>

									<ng-container *ngSwitchCase="'LLTP'">
										<div fxFlex="15" fxLayoutAlign="end">
											{{
												getPrice(item, this.numberOfLltpSeats) | number : "1.2-2"
											}}
										</div>
									</ng-container>

									<ng-container *ngSwitchCase="'GCKT'">
										<div fxFlex="15" fxLayoutAlign="end">
											{{
												getPrice(item, addOnFrmGroup.value.gckt)
													| number : "1.2-2"
											}}
										</div>
									</ng-container>

									<ng-container *ngSwitchCase="'VA'">
										<div fxFlex="15" fxLayoutAlign="end">
											{{
												getPrice(item, addOnFrmGroup.value.va) | number : "1.2-2"
											}}
										</div>
									</ng-container>

									<ng-container *ngSwitchDefault>
										<div fxFlex="15" fxLayoutAlign="end">
											{{ getPrice(item) | number : "1.2-2" }}
										</div>
									</ng-container>
								</ng-container>
							</div>
						</ng-container>
					</ng-container>

					<div
						fxLayout="row"
						fxLayoutAlign="space-between"
						style="
							font-weight: bold;
							margin: 10px 0px;
							background-color: #f4f6faff;
						"
					>
						<div fxFlex="75">{{ "common.totalGrossPremium" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ getPaymentValues().grossPremium | number : "1.2-2" }}
						</div>
					</div>

					<div fxLayout="row" fxLayoutAlign="space-between">
						<div fxFlex="75">{{ "common.serviceTax" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ getPaymentValues().taxAmount | number : "1.2-2" }}
						</div>
					</div>

					<div fxLayout="row" fxLayoutAlign="space-between">
						<div fxFlex="75">{{ "common.stampDuty" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ selectedQuotation?.stampDutyPrice | number : "1.2-2" }}
						</div>
					</div>

					<div
						fxLayout="row"
						fxLayoutAlign="space-between"
						style="
							font-weight: bold;
							margin: 10px 0px;
							background-color: #f4f6faff;
						"
					>
						<div fxFlex="75">{{ "common.totalNetPremium" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ getPaymentValues().totalNetPremium | number : "1.2-2" }}
						</div>
					</div>

					<div
						fxLayout="row"
						fxLayoutAlign="space-between"
						*ngIf="selectedQuotation?.platformDiscountRate !== 0"
					>
						<div fxFlex="75">{{ "common.platformOffer" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div
							fxFlex="15"
							fxLayoutAlign="end"
							style="font-weight: bold; color: red"
						>
							-
							{{
								getPaymentValues().platformDiscountRateAmount | number : "1.2-2"
							}}
						</div>
					</div>

					<div
						fxLayout="row"
						fxLayoutAlign="space-between"
						*ngIf="addOnFrmGroup.value?.isIncludeRoadtax"
					>
						<div fxFlex="75">{{ "addOn.roadTax" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ requestData.roadTaxPrice | number : "1.2-2" }}
						</div>
					</div>

					<div
						fxLayout="row"
						fxLayoutAlign="space-between"
						*ngIf="
							addOnFrmGroup.value?.isIncludeRoadtax && !isIncludeDigitalRoadtax
						"
					>
						<div fxFlex="75">{{ "addOn.roadTaxDelivery" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ requestData.roadTaxDeliveryPrice | number : "1.2-2" }}
						</div>
					</div>

					<!-- Non SST Add On List -->
					<ng-container *ngFor="let item of selectedAddOn">
						<ng-container *ngIf="!item.isIncludeSST && !item.hidePriceBreakdown">
							<div fxLayout="row" fxLayoutAlign="space-between">
								<ng-container *ngIf="item.customCode != 'UnlimitedTowing_PA'">
									<div fxFlex="75">
										Add On: {{ "addOn." + item.code | translate }} *
									</div>
								</ng-container>
								<ng-container *ngIf="item.customCode == 'UnlimitedTowing_PA'">
									<div fxFlex="75">
										Add On: {{ "addOn." + item.customCode | translate }} *
									</div>
								</ng-container>
								<div fxFlex="10" fxLayoutAlign="end">RM</div>
								<div fxFlex="15" fxLayoutAlign="end">
									<ng-container *ngIf="item.customCode != 'UnlimitedTowing_PA'">
										{{ getPrice(item) | number : "1.2-2" }}
									</ng-container>
									
									<ng-container *ngIf="item.customCode == 'UnlimitedTowing_PA'">
										{{ getPrice(item, this.numberOfLltpSeats) | number : "1.2-2" }}
									</ng-container>
								</div>
							</div>
						</ng-container>
					</ng-container>

					<div
						fxLayout="row"
						fxLayoutAlign="space-between"
						style="
							font-weight: bold;
							margin: 10px 0px;
							background-color: #f4f6faff;
						"
					>
						<div fxFlex="75">{{ "common.totalCharges" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ getPaymentValues().totalCharge | number : "1.2-2" }}
						</div>
					</div>

					<div fxLayout="row" fxLayoutAlign="space-between" *ngIf="promo">
						<div fxFlex="75">{{ promo.name }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end" class="color-red">
							- {{ getPaymentValues().totalPromo | number : "1.2-2" }}
						</div>
					</div>

					<div
						fxLayout="row"
						fxLayoutAlign="space-between"
						*ngIf="selectedQuotation?.serviceTaxRate !== 0"
					>
						<div fxFlex="75">{{ "common.serviceFee" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ getPaymentValues().serviceFee | number : "1.2-2" }}
						</div>
					</div>

					<div
						fxLayout="row"
						fxLayoutAlign="space-between"
						style="
							font-weight: bold;
							margin-top: 10px;
							color: #0091ff;
							background-color: #f4f6faff;
						"
					>
						<div fxFlex="75">{{ "common.totalAmount" | translate }}</div>
						<div fxFlex="10" fxLayoutAlign="end">RM</div>
						<div fxFlex="15" fxLayoutAlign="end">
							{{ getTotal() | number : "1.2-2" }}
						</div>
					</div>
				</div>

				<div fxLayout="center" class="summary-disclaimer">
					<img src="https://storage.googleapis.com/ps-asset/ps_icons/calendar.svg" alt="" /> {{ "comparison.printDesc1" | translate: { numOfDays: 7 } }}
				</div>
				<div fxLayout="center" class="summary-disclaimer">
					<img src="https://storage.googleapis.com/ps-asset/ps_icons/currency.svg" alt="" /> {{ "comparison.printDesc2" | translate }}
				</div>
				<div fxLayout="center" class="summary-disclaimer">
					{{ "comparison.printDesc3" | translate }}
				</div>

				<div fxLayout="row" fxLayoutAlign="end" class="summary-footer">
					<div class="summary-footer-brand-title">{{ "comparison.poweredBy" | translate }}</div>
					<div fxLayout="column" class="summary-footer-brand-content">
						<img src="https://storage.googleapis.com/ps-asset/ps_logos/pslogo-ver2.png" width="130" />
						<div style="font-size: 10px;">{{ "comparison.companyDesc1" | translate }}</div>
						<div style="font-size: 10px; margin-bottom: 5px;">{{ "comparison.companyDesc2" | translate }}</div>
						<div style="font-size:8px;">{{ "comparison.companyDesc3" | translate }}</div>
					</div>
				</div>
			</div>
		</div>
	</iframe>
</ng-template>


<ng-template #addOnFrom>
	<form [formGroup]="addOnFrmGroup">
		<!-- Road Tax -->
		<mat-card
			class="addon-card"
			*ngIf="!requestData.eHailingUsed"
			[class.selected]="addOnFrmGroup.value?.isIncludeRoadtax"
		>
			<mat-checkbox
				formControlName="isIncludeRoadtax"
				(change)="toggleRoadTax($event)"
				[checked]="isRoadTaxSelected(addOnFrmGroup.value?.isIncludeRoadtax)"
			>
				<div fxLayout="row" class="addon-title">
					<div fxFlex class="title">
						{{ "dashboard.roadTaxRenewTitle" | translate }}
					</div>
					<div class="value">
						<span>RM</span>
						{{ addOnFrmGroup?.value?.roadTaxPrice | number : "1.2-2" }}
					</div>
					<mat-icon
						class="tooltip-icon"
						[matMenuTriggerFor]="roadTaxTooltip"
						#roadTaxTrigger="matMenuTrigger"
						(mouseenter)="roadTaxTrigger.openMenu()"
					>
						info
					</mat-icon>
					<mat-menu
						#roadTaxTooltip="matMenu"
						[overlapTrigger]="false"
						class="tooltip-popover"
					>
						<span (mouseleave)="roadTaxTrigger.closeMenu()">
							{{ "addOn.roadTaxTooltip" | translate }}
						</span>
					</mat-menu>
				</div>
			</mat-checkbox>
			<mat-radio-group
				*ngIf="showRoadTaxList"
				(change)="radioDigitalRoadTaxChange($event)"
				style="padding-left: 10px !important"
			>
				<mat-radio-button
					[value]="includeDigitalRoadTax"
					[checked]="requestData.isMalaysian && !requestData.isCompany"
					*ngIf="requestData.isMalaysian && !requestData.isCompany"
				>
					<ng-container>
						<div fxLayout="row" fxLayoutAlign="center">
							<div fxFlex>
								{{ "addOn.digitalRoadTax" | translate }}
							</div>
							<div class="sub-right">
								<!-- <del>RM 8.00</del>  -->
								{{ "addOn.capitalFree" | translate }}
								<div class="sub-value">
									{{ "addOn.limitedTimeOnly" | translate }}
								</div>
							</div>
						</div>
					</ng-container>
				</mat-radio-button>
				<mat-radio-button
					[value]="!includeDigitalRoadTax"
					[checked]="!requestData.isMalaysian || requestData.isCompany"
				>
					<ng-container>
						<div fxLayout="row" fxLayoutAlign="center">
							<div fxFlex>
								{{ "addOn.physicalRoadtax" | translate }}
							</div>
							<div class="sub-right">
								RM {{ requestData.roadTaxDeliveryPrice | number : "1.2-2" }}
								<div class="sub-value">
									{{ "addOn.handlingFee" | translate }}
								</div>
							</div>
						</div>
					</ng-container>
				</mat-radio-button>
			</mat-radio-group>
			<ng-container
				*ngIf="addOnFrmGroup.value?.isIncludeRoadtax && showRoadTaxList"
			>
				<div fxLayout="row">
					<mat-checkbox fxFlex color="warn" formControlName="isNotBlacklisted">
						{{ "addOn.isNotBlacklisted" | translate }}
					</mat-checkbox>
				</div>
			</ng-container>
			<div
				*ngIf="addOnFrmGroup.value?.isIncludeRoadtax && showRoadTaxList"
				class="roadtax-content__notice"
			>
				<div class="roadtax-content__notice__title">
					{{ "addOn.roadTaxNoticeTitle" | translate }}
				</div>
				<div
					class="roadtax-content__notice__desc"
					[innerHTML]="'addOn.roadTaxNoticeDesc' | translate"
				></div>
			</div>
		</mat-card>

		<ng-container *ngFor="let category of addOnOptionalCategory">
			<ng-template
				#addOn
				[ngTemplateOutlet]="addOn"
				let-addOnList="addOnList"
				[ngTemplateOutletContext]="{
					addOnList: getAddOnListByCategory(category)
				}"
			>
				<ng-container [ngSwitch]="category">
					<ng-container *ngSwitchCase="'Windshield'">
						<ng-template
							#Windshield
							[ngTemplateOutlet]="Windshield"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div fxFlex class="title">
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{
												getPrice(addOn, addOnFrmGroup.value.windshield)
													| number : "1.2-2"
											}}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="windshieldTooltip"
											#windshieldTrigger="matMenuTrigger"
											(mouseenter)="windshieldTrigger.openMenu()"
										>
											info</mat-icon
										>
										<mat-menu
											#windshieldTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="windshieldTrigger.closeMenu()">
												{{ "addOn.WindshiledTooltip" | translate }}
											</span>
										</mat-menu>
									</div>
								</mat-checkbox>

								<ng-container *ngIf="isAddOnSelected(addOn)">
									<div class="coverage-desc fit">
										<mat-form-field appearance="outline" class="full-width">
											<mat-label>{{
												"addOn.coverageAmount" | translate
											}}</mat-label>
											<input
												matInput
												formControlName="windshield"
												mask="separator.2"
												thousandSeparator=","
												separatorLimit="99999999999999"
											/>
											<mat-error
												style="display: block !important"
												[hidden]="
													!addOnFrmGroup.controls.windshield?.errors?.windshield
												"
											>
												{{ "error.invalidWindshield" | translate }}
												{{ windshieldMin }} and {{ windshieldMax }}</mat-error
											>
										</mat-form-field>
									</div>
									<ng-container
										*ngIf="
											(selectedQuotation.code == 'Zurich' ||
												selectedQuotation.code == 'Zurich_Takaful') &&
											!requestData?.isCompany
										"
									>
										<div fxLayout="row">
											<mat-checkbox
												fxFlex
												color="warn"
												formControlName="isWindshieldExceeded"
											>
												{{ "addOn.isWindshieldExceeded1" | translate
												}}<b>{{ "addOn.isWindshieldExceeded2" | translate }}</b
												>{{ "addOn.isWindshieldExceeded3" | translate }}
											</mat-checkbox>
										</div>
									</ng-container>
								</ng-container>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'Flood'">
						<mat-card
							class="addon-card"
							[class.selected]="hasSelectedCategory('Flood')"
						>
							<ng-container *ngIf="addOnList.length === 1">
								<ng-template
									#flood
									[ngTemplateOutlet]="flood"
									let-addOn="addOn"
									[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
								>
									<mat-checkbox
										[value]="addOn"
										(change)="toggleAddOn($event)"
										[checked]="isAddOnSelected(addOn)"
									>
										<div fxLayout="row">
											<div fxFlex class="title">
												{{ "addOn." + addOn?.code | translate }}
											</div>
											<div class="value">
												<span>RM</span>
												{{ getPrice(addOn) | number : "1.2-2" }}
											</div>
											<mat-icon
												class="tooltip-icon"
												[matMenuTriggerFor]="FloodTooltip"
												#FloodTrigger="matMenuTrigger"
												(mouseenter)="FloodTrigger.openMenu()"
											>
												info</mat-icon
											>
											<mat-menu
												#FloodTooltip="matMenu"
												[overlapTrigger]="false"
												class="tooltip-popover"
											>
												<span (mouseleave)="FloodTrigger.closeMenu()">
													{{ "addOn.FloodTooltip" | translate }}
												</span>
											</mat-menu>
										</div>

										<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
											{{ "addOn.coverage" | translate }}:
											<ul>
												<li>{{ "addOn.fullFloodDesc" | translate }}</li>
											</ul>
										</div>
									</mat-checkbox>
								</ng-template>
							</ng-container>

							<ng-container *ngIf="addOnList.length !== 1">
								<ng-template
									#flood
									[ngTemplateOutlet]="flood"
									let-addOn="addOn"
									[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
								>
									<mat-checkbox
										[(ngModel)]="isFloodChecked"
										[ngModelOptions]="{ standalone: true }"
										[value]="addOn"
										(change)="toggleAddOn($event)"
										[checked]="isAddOnSelected(addOn)"
									>
										<div fxLayout="row">
											<div fxFlex class="title">
												{{ "addOn.Flood" | translate }}
											</div>
											<mat-icon
												class="tooltip-icon"
												[matMenuTriggerFor]="FloodTooltip"
												#FloodTrigger="matMenuTrigger"
												(mouseenter)="FloodTrigger.openMenu()"
											>
												info
											</mat-icon>
											<mat-menu
												#FloodTooltip="matMenu"
												[overlapTrigger]="false"
												class="tooltip-popover"
											>
												<span (mouseleave)="FloodTrigger.closeMenu()">
													{{ "addOn.FloodTooltip" | translate }}
												</span>
											</mat-menu>
										</div>
									</mat-checkbox>
								</ng-template>
								<mat-radio-group
									*ngIf="isFloodChecked"
									(change)="radioChange($event.value)"
								>
									<mat-radio-button
										*ngFor="let item of addOnList; let first = first"
										[value]="item"
										[checked]="first"
									>
										<div fxLayout="row">
											<div class="title" fxFlex>
												{{ "addOn." + item.code | translate }}
											</div>
											<div class="value">
												<span>RM</span>
												{{ getPrice(item) | number : "1.2-2" }}
											</div>
										</div>
										<div class="coverage-desc" *ngIf="isAddOnSelected(item)">
											{{ "addOn.coverage" | translate }}:
											<ul>
												<li *ngIf="item.code === 'FullFloodPeril'">
													{{ "addOn.fullFloodDesc" | translate }}
												</li>
												<li *ngIf="item.code === 'LimitedFloodPeril'">
													{{ "addOn.limitedFloodDesc" | translate }}
												</li>
											</ul>
										</div>
									</mat-radio-button>
								</mat-radio-group>
							</ng-container>
						</mat-card>
					</ng-container>

					<ng-container *ngSwitchCase="'SpecialPerils'">
						<mat-card
							class="addon-card"
							[class.selected]="hasSelectedCategory('SpecialPerils')"
						>
							<ng-container *ngIf="addOnList.length === 1">
								<ng-template
									#specialPerils
									[ngTemplateOutlet]="specialPerils"
									let-addOn="addOn"
									[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
								>
									<mat-checkbox
										[value]="addOn"
										(change)="toggleAddOn($event)"
										[checked]="isAddOnSelected(addOn)"
									>
										<div fxLayout="row">
											<div fxFlex class="title">
												{{ "addOn." + addOn?.code | translate }}
											</div>
											<div class="value">
												<span>RM</span>
												{{ getPrice(addOn) | number : "1.2-2" }}
											</div>
										</div>
									</mat-checkbox>
								</ng-template>
							</ng-container>
						</mat-card>
					</ng-container>

					<ng-container *ngSwitchCase="'EHailing'">
						<ng-template
							#eHailing
							[ngTemplateOutlet]="eHailing"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{ getPrice(addOn) | number : "1.2-2" }}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="EHailingTooltip"
											#EHailingTrigger="matMenuTrigger"
											(mouseenter)="EHailingTrigger.openMenu()"
										>
											info</mat-icon
										>
										<mat-menu
											#EHailingTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="EHailingTrigger.closeMenu()">
												{{ "addOn.EHailingTooltip" | translate }}
											</span>
										</mat-menu>
									</div>

									<div
										class="coverage-desc"
										style="white-space: normal"
										*ngIf="isAddOnSelected(addOn)"
									>
										{{ "addOn.eHailingDesc" | translate }}
									</div>
								</mat-checkbox>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'LLOPNA'">
						<ng-template
							#LLOPNA
							[ngTemplateOutlet]="LLOPNA"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row wrap">
										<div class="title" fxFlex="70">
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<span fxFlex></span>
										<div class="value">
											<span>RM</span>
											{{ getPrice(addOn) | number : "1.2-2" }}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="LLOPNATooltip"
											#LLOPNATrigger="matMenuTrigger"
											(mouseenter)="LLOPNATrigger.openMenu()"
										>
											info</mat-icon
										>
										<mat-menu
											#LLOPNATooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="LLOPNATrigger.closeMenu()">
												{{ "addOn.LLOPNATooltip" | translate }}
											</span>
										</mat-menu>
									</div>
									<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
										{{ "addOn.coverage" | translate }}:
										<ul>
											<li>{{ "addOn.LLDesc1" | translate }}</li>
											<li>{{ "addOn.LLDesc2" | translate }}</li>
										</ul>
									</div>
								</mat-checkbox>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'SRCC'">
						<ng-template
							#SRCC
							[ngTemplateOutlet]="SRCC"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{ getPrice(addOn) | number : "1.2-2" }}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="SRCCTooltip"
											#SRCCTrigger="matMenuTrigger"
											(mouseenter)="SRCCTrigger.openMenu()"
										>
											info
										</mat-icon>
										<mat-menu
											#SRCCTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="SRCCTrigger.closeMenu()">
												{{ "addOn.SRCCTooltip" | translate }}
											</span>
										</mat-menu>
									</div>
									<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
										{{ "addOn.coverage" | translate }}:
										<ul>
											<li>{{ "addOn.SRCCDesc" | translate }}</li>
										</ul>
									</div>
								</mat-checkbox>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'LLTP'">
						<ng-template
							#LLTP
							[ngTemplateOutlet]="LLTP"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{
												getPrice(addOn, this.numberOfLltpSeats)
													| number : "1.2-2"
											}}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="LLTPTooltip"
											#LLTPTrigger="matMenuTrigger"
											(mouseenter)="LLTPTrigger.openMenu()"
										>
											info
										</mat-icon>
										<mat-menu
											#LLTPTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="LLTPTrigger.closeMenu()">
												{{ "addOn.LLTPTooltip" | translate }}
											</span>
										</mat-menu>
									</div>
									<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
										{{ "addOn.coverage" | translate }}:
										<label class="seat-label">
											{{ numberOfLltpSeats }} {{ "common.seats" | translate }}
										</label>
										<ul>
											<li>{{ "addOn.LLDesc1" | translate }}</li>
											<li>{{ "addOn.LLDesc2" | translate }}</li>
										</ul>
									</div>
								</mat-checkbox>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'FGAP'">
						<ng-template
							#FGAP
							[ngTemplateOutlet]="FGAP"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="FGAPTooltip"
											#FGAPTrigger="matMenuTrigger"
											(mouseenter)="FGAPTrigger.openMenu()"
										>
											info
										</mat-icon>
										<mat-menu
											#FGAPTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="FGAPTrigger.closeMenu()">
												{{ "addOn.FGAPTooltip" | translate }}
											</span>
										</mat-menu>
									</div>
								</mat-checkbox>
								<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
									<section class="box-selection mv-sm">
										<mat-radio-group
											class="b2c-radio fgap-radio-btn"
											formControlName="fgap"
										>
											<mat-radio-button
												[value]="getPrice(addOn, '0')"
												(change)="fgapAddOnsChanged('0')"
												selected
												[checked]="true"
											>
												<div fxLayout="row" fxLayoutAlign="space-between ">
													<div>
														<div class="value-desc">Plan 1</div>
														<div class="smDesc-f">
															(Maximum limit: RM 10,000)
														</div>
													</div>
													<div class="mdTitle-f">
														<span>RM </span>
														{{ getPrice(addOn, "0") | number : "1.2-2" || "-" }}
													</div>
												</div>
											</mat-radio-button>
											<mat-radio-button
												[value]="getPrice(addOn, '1')"
												(change)="fgapAddOnsChanged('1')"
											>
												<div fxLayout="row" fxLayoutAlign="space-between ">
													<div>
														<div class="value-desc">Plan 2</div>
														<div class="smDesc-f">
															(Maximum limit: RM 20,000)
														</div>
													</div>

													<div class="mdTitle-f">
														<span>RM </span
														>{{
															getPrice(addOn, "1") | number : "1.2-2" || "-"
														}}
													</div>
												</div>
											</mat-radio-button>
											<mat-radio-button
												[value]="getPrice(addOn, '2')"
												(change)="fgapAddOnsChanged('2')"
											>
												<div fxLayout="row" fxLayoutAlign="space-between ">
													<div>
														<div class="value-desc">Plan 3</div>
														<div class="smDesc-f">
															(Maximum limit: RM 30,000)
														</div>
													</div>
													<div class="mdTitle-f">
														<span>RM </span>
														{{ getPrice(addOn, "2") | number : "1.2-2" || "-" }}
													</div>
												</div>
											</mat-radio-button>
										</mat-radio-group>
									</section>
								</div>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'MERW'">
						<ng-template
							#MERW
							[ngTemplateOutlet]="MERW"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="MERWTooltip"
											#MERWTrigger="matMenuTrigger"
											(mouseenter)="MERWTrigger.openMenu()"
										>
											info
										</mat-icon>
										<mat-menu
											#MERWTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<div
												(mouseleave)="MERWTrigger.closeMenu()"
												[innerHTML]="'addOn.MERWTooltip' | translate"
											></div>
										</mat-menu>
									</div>
								</mat-checkbox>
								<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
									<section class="box-selection mv-sm">
										<mat-radio-group
											class="b2c-radio fgap-radio-btn"
											formControlName="merw"
										>
											<mat-radio-button
												[value]="getPrice(addOn)"
												(change)="fgapAddOnsChanged('0')"
												selected
												[checked]="true"
											>
												<div fxLayout="row" fxLayoutAlign="space-between ">
													<div>
														<div class="value-desc">
															{{ "addOn.MERWPlanA" | translate }}
														</div>
													</div>
													<div class="mdTitle-f">
														<span>RM </span>
														{{ getPrice(addOn) | number : "1.2-2" || "-" }}
													</div>
												</div>
											</mat-radio-button>
											<!-- For future Plan B -->
											<!-- <mat-radio-button
												[value]="getPrice(addOn, '1')"
												(change)="fgapAddOnsChanged('1')"
											>
												<div fxLayout="row" fxLayoutAlign="space-between ">
													<div>
														<div class="value-desc">Plan B</div>
													</div>

													<div class="mdTitle-f">
														<span>RM </span
														>{{
															getPrice(addOn, "1") | number : "1.2-2" || "-"
														}}
													</div>
												</div>
											</mat-radio-button> -->
											<!-- For future Plan C -->
											<!-- <mat-radio-button
												[value]="getPrice(addOn, '2')"
												(change)="fgapAddOnsChanged('2')"
											>
												<div fxLayout="row" fxLayoutAlign="space-between ">
													<div>
														<div class="value-desc">Plan C</div>
													</div>
													<div class="mdTitle-f">
														<span>RM </span>
														{{ getPrice(addOn, "2") | number : "1.2-2" || "-" }}
													</div>
												</div>
											</mat-radio-button> -->
										</mat-radio-group>
									</section>
								</div>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'UnlimitedTowing'">
						<ng-template
							#UnlimitedTowing
							[ngTemplateOutlet]="UnlimitedTowing"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card UnlimitedTowing"
								[class.selected]="isAddOnSelected(addOn)"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{ getPrice(addOn) | number : "1.2-2" }}
										</div>
									</div>
								</mat-checkbox>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'Drivers'">
						<mat-card
							class="addon-card"
							[class.selected]="hasSelectedCategory('Drivers')"
						>
							<ng-container *ngIf="addOnList.length === 1">
								<ng-template
									#drivers
									[ngTemplateOutlet]="drivers"
									let-addOn="addOn"
									[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
								>
									<ng-container>
										<mat-checkbox
											[value]="addOn"
											(change)="toggleAddOn($event)"
											[checked]="isAddOnSelected(addOn)"
										>
											<div fxLayout="row">
												<div class="title" fxFlex>
													{{ "addOn." + (addOn?.code === 'UnlimitedDrivers' && isChubbIQ ? 'UnlimitedDriversChubb' : addOn?.code) | translate }}
												</div>
												<div
													class="value"
													*ngIf="addOn?.code !== 'AdditionalDrivers'"
												>
													<span>RM</span>
													{{ getPrice(addOn) | number : "1.2-2" }}
												</div>
												<mat-icon
													class="tooltip-icon"
													[matMenuTriggerFor]="unlimitedTooltip"
													#unlimitedTrigger="matMenuTrigger"
													(mouseenter)="unlimitedTrigger.openMenu()"
												>
													info
												</mat-icon>
												<mat-menu
													#unlimitedTooltip="matMenu"
													[overlapTrigger]="false"
													class="tooltip-popover"
												>
													<span (mouseleave)="unlimitedTrigger.closeMenu()">
														{{ "addOn.UnlimitedTooltip" | translate }}
													</span>
												</mat-menu>
												<div
													class="value text-right"
													*ngIf="addOn?.code === 'AdditionalDrivers'"
												>
													{{ "addOn.free" | translate }}
													<div
														class="sub-value"
														[translate]="'addOn.additionalDriverDesc'"
														[translateParams]="{
															val:
																maxAdditionalDriver ??
																translate.instant('number.1')
														}"
													></div>
												</div>
											</div>
										</mat-checkbox>
									</ng-container>
								</ng-template>
							</ng-container>
							<ng-container *ngIf="addOnList.length !== 1">
								<mat-checkbox
									[(ngModel)]="isDriverChecked"
									[ngModelOptions]="{ standalone: true }"
									(change)="radioChange(addOnList[0], true)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn.AdditionalDrivers" | translate }}
										</div>
									</div>
								</mat-checkbox>

								<mat-radio-group
									*ngIf="isDriverChecked"
									(change)="radioChange($event.value)"
								>
									<mat-radio-button
										*ngFor="let item of addOnList; let first = first"
										class="top-aligned-radio"
										[value]="item"
										[checked]="first"
									>
										<ng-container *ngIf="item.code !== 'AdditionalDrivers'">
											<div fxLayout="row" fxLayoutAlign=" center">
												<div class="title" fxFlex>
													{{ "addOn.UnlimitedDrivers" | translate }}
												</div>
												<div class="value sub-right">
													<span>RM</span>
													{{ getPrice(item, +item.evaluate) | number : "1.2-2" }}
												</div>
											</div>
										</ng-container>

										<ng-container *ngIf="item.code === 'AdditionalDrivers'">
											<div fxLayout="row">
												<div class="title" fxFlex>
													{{ "addOn.additionalDriver" | translate }}
												</div>
												<div
													class="value"
													*ngIf="
														getFormArray()?.controls.length > 1;
														else freeDriverText
													"
												>
													<span>RM</span>
													{{
														getPrice(item, getFormArray()?.controls.length)
															| number : "1.2-2"
													}}
												</div>
												<ng-template #freeDriverText>
													<div class="value text-right">
														{{ "addOn.free" | translate }}
														<div
															class="sub-value"
															[translate]="'addOn.additionalDriverDesc'"
															[translateParams]="{
																val:
																	maxAdditionalDriver ??
																	translate.instant('number.1')
															}"
														></div>
													</div>
												</ng-template>
												<mat-icon
													class="tooltip-icon"
													[matMenuTriggerFor]="AdditionalDriversTooltip"
													#AdditionalDriversTrigger="matMenuTrigger"
													(mouseenter)="AdditionalDriversTrigger.openMenu()"
												>
													info
												</mat-icon>
											</div>

											<mat-menu
												#AdditionalDriversTooltip="matMenu"
												[overlapTrigger]="false"
												class="tooltip-popover"
											>
												<span
													(mouseleave)="AdditionalDriversTrigger.closeMenu()"
												>
													{{ "addOn.AdditionalDriversTooltip" | translate }}
												</span>
											</mat-menu>
										</ng-container>
									</mat-radio-button>
								</mat-radio-group>
							</ng-container>
							<ng-container *ngIf="hasSelectedCode('AdditionalDrivers')">
								<div
									formArrayName="drivers"
									*ngFor="let item of getFormArray()?.controls; let i = index"
								>
									<br />
									<ng-container [formGroupName]="i">
										<div fxLayout="row" fxLayoutAlign=" center">
											<div class="driver-count">
												{{ "addOn.additionalDriver" | translate }} #{{ i + 1 }}
											</div>
											<div class="driver-divider" fxFlex></div>
											<button
												class="driver-delete"
												(click)="deleteDriver(i)"
												mat-icon-button
												*ngIf="i !== 0"
												type="button"
											>
												<mat-icon>delete_outline</mat-icon>
											</button>
										</div>

										<br />

										<div class="form-wrapper">
											<div>
												<mat-form-field appearance="outline">
													<mat-label
														>{{ "common.name" | translate }}
													</mat-label>
													<input
														matInput
														required
														autocomplete="off"
														formControlName="name"
													/>
													<mat-error>
														{{ "common.name" | translate }}
														{{
															getFormArrayControlError(i, "name")
																| inputError
																| translate
														}}
													</mat-error>
												</mat-form-field>

												<div class="sub-form-wrapper">
													<mat-form-field
														class="form-dropdown"
														appearance="outline"
													>
														<mat-select formControlName="idType">
															<mat-option
																*ngFor="let item of idTypeList"
																[value]="item.codeValue"
															>
																{{ item.codeDesc }}
															</mat-option>
														</mat-select>
													</mat-form-field>

													<mat-form-field
														class="form-input"
														appearance="outline"
													>
														<mat-label
															>{{ "common.idNo" | translate }}
														</mat-label>
														<input
															matInput
															required
															autocomplete="off"
															[mask]="
																item.get('idType').value === 'IC_NO'
																	? '000000000000'
																	: ''
															"
															formControlName="identityNo"
														/>
														<mat-error>
															{{ "common.idNo" | translate }}
															{{
																getFormArrayControlError(i, "identityNo")
																	| inputError
																	| translate
															}}
														</mat-error>
													</mat-form-field>
												</div>

												<mat-form-field appearance="outline">
													<mat-label>{{ "common.dob" | translate }} </mat-label>
													<input
														matInput
														readonly
														required
														[matDatepicker]="picker"
														formControlName="dob"
														(click)="picker.open()"
														[max]="maxDob"
													/>
													<mat-datepicker-toggle
														matSuffix
														[for]="picker"
													></mat-datepicker-toggle>
													<mat-datepicker #picker></mat-datepicker>
													<mat-error>
														{{ "common.dob" | translate }}
														{{
															getFormArrayControlError(i, "dob")
																| inputError
																| translate
														}}
													</mat-error>
												</mat-form-field>
											</div>

											<div class="additional-radio-btn">
												<mat-label
													>{{ "common.gender" | translate }}
												</mat-label>
												<mat-radio-group
													aria-label="Select an option"
													formControlName="gender"
												>
													<mat-radio-button value="M">
														{{ "common.M" | translate }}
													</mat-radio-button>
													<mat-radio-button value="F">
														{{ "common.F" | translate }}
													</mat-radio-button>
												</mat-radio-group>
											</div>

											<div class="additional-radio-btn">
												<mat-label
													>{{ "common.maritalStatus" | translate }}
												</mat-label>
												<mat-radio-group
													aria-label="Select an option"
													formControlName="maritalStatus"
												>
													<mat-radio-button value="Single">
														{{ "common.Single" | translate }}
													</mat-radio-button>
													<mat-radio-button value="Married">
														{{ "common.Married" | translate }}
													</mat-radio-button>
												</mat-radio-group>
											</div>

											<mat-form-field appearance="outline">
												<mat-label>{{
													"common.relationship" | translate
												}}</mat-label>
												<mat-select
													required
													formControlName="relationship"
													placeholder="Please select"
												>
													<mat-option
														*ngFor="let item of relationshipList"
														[value]="item.id"
													>
														{{ item.name | translate }}
													</mat-option>
												</mat-select>
												<mat-error>
													{{ "common.relationship" | translate }}
													{{
														getFormArrayControlError(i, "relationship")
															| inputError
															| translate
													}}
												</mat-error>
											</mat-form-field>
										</div>
									</ng-container>
								</div>
								<button
									*ngIf="
										!maxAdditionalDriver ||
										getFormArray()?.length < maxAdditionalDriver
									"
									(click)="addDriver()"
									type="button"
									mat-stroked-button
									class="add-driver-btn"
								>
									<mat-icon>add_circle</mat-icon>
									{{ "addOn.addDriver" | translate }}
								</button>
							</ng-container>
						</mat-card>
					</ng-container>

					<ng-container *ngSwitchCase="'VBET'">
						<mat-card
							class="addon-card"
							[class.selected]="hasSelectedCategory('VBET')"
						>
							<ng-container *ngIf="addOnList.length === 1">
								<ng-template
									#VBET
									[ngTemplateOutlet]="VBET"
									let-addOn="addOn"
									[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
								>
									<mat-checkbox
										[value]="addOn"
										(change)="toggleAddOn($event)"
										[checked]="isAddOnSelected(addOn)"
									>
										<div fxLayout="row">
											<div fxFlex class="title">
												{{ "addOn." + addOn?.code | translate }}
											</div>
											<div class="value">
												<span>RM</span>
												{{ getPrice(addOn) | number : "1.2-2" }}
											</div>
											<mat-icon
												class="tooltip-icon"
												[matMenuTriggerFor]="VBETTooltip"
												#VBETTrigger="matMenuTrigger"
												(mouseenter)="VBETTrigger.openMenu()"
											>
												info</mat-icon
											>
											<mat-menu
												#VBETTooltip="matMenu"
												[overlapTrigger]="false"
												class="tooltip-popover"
											>
												<span (mouseleave)="VBETTrigger.closeMenu()">
													{{ "addOn.VBETTooltip" | translate }}
												</span>
											</mat-menu>
										</div>
									</mat-checkbox>
								</ng-template>
							</ng-container>

							<ng-container *ngIf="addOnList.length !== 1">
								<ng-template
									#VBET
									[ngTemplateOutlet]="VBET"
									let-addOn="addOn"
									[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
								>
									<mat-checkbox
										[(ngModel)]="isVBETChecked"
										[ngModelOptions]="{ standalone: true }"
										[value]="addOn"
										(change)="toggleAddOn($event)"
										[checked]="isAddOnSelected(addOn)"
									>
										<div fxLayout="row">
											<div fxFlex class="title">
												{{ "addOn.VBET" | translate }}
											</div>
											<mat-icon
												class="tooltip-icon"
												[matMenuTriggerFor]="VBETTooltip"
												#VBETTrigger="matMenuTrigger"
												(mouseenter)="VBETTrigger.openMenu()"
											>
												info
											</mat-icon>
											<mat-menu
												#VBETTooltip="matMenu"
												[overlapTrigger]="false"
												class="tooltip-popover"
											>
												<span (mouseleave)="VBETTrigger.closeMenu()">
													{{ "addOn.VBETTooltip" | translate }}
												</span>
											</mat-menu>
										</div>
									</mat-checkbox>
								</ng-template>
							</ng-container>
						</mat-card>
					</ng-container>

					<ng-container *ngSwitchCase="'BISP'">
						<ng-template
							#BISP
							[ngTemplateOutlet]="BISP"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{ getPrice(addOn) | number : "1.2-2" }}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="BISPTooltip"
											#BISPTrigger="matMenuTrigger"
											(mouseenter)="BISPTrigger.openMenu()"
										>
											info
										</mat-icon>
										<mat-menu
											#BISPTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="BISPTrigger.closeMenu()">
												{{ "addOn.BISPTooltip" | translate }}
											</span>
										</mat-menu>
									</div>
									<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
										{{ "addOn.coverage" | translate }}:
										<ul>
											<li>{{ "addOn.BISPDesc" | translate }}</li>
										</ul>
									</div>
								</mat-checkbox>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'MPAPlus'">
						<ng-template
							#MPAPlus
							[ngTemplateOutlet]="MPAPlus"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{ getPrice(addOn) | number : "1.2-2" }}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="MPAPlusTooltip"
											#MPAPlusTrigger="matMenuTrigger"
											(mouseenter)="MPAPlusTrigger.openMenu()"
										>
											info
										</mat-icon>
										<mat-menu
											#MPAPlusTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="MPAPlusTrigger.closeMenu()">
												{{ "addOn.MPAPlusTooltip" | translate }}
											</span>
										</mat-menu>
									</div>
									<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
										{{ "addOn.coverage" | translate }}:
										<ul>
											<li>{{ "addOn.MPAPlusDesc" | translate }}</li>
										</ul>
									</div>
								</mat-checkbox>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'PA'">
						<ng-template #PAPlan [ngTemplateOutlet]="PAPlan" let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }">
							<mat-card class="addon-card" [class.selected]="isAddOnSelected(addOn)" *ngIf="addOn">
								<mat-checkbox [value]="addOn" (change)="toggleAddOn($event)" [checked]="isAddOnSelected(addOn)">
									<!-- normal PA -->
									<ng-container *ngIf="addOn.customCode != 'UnlimitedTowing_PA' && addOn.customCode != 'IMOTORBIKE'">
										<div fxLayout="row">
											<div class="title" fxFlex>
												{{ "addOn." + addOn?.code | translate }}
											</div>
											<div class="value">
												<span>RM</span>
												{{ getPrice(addOn) | number : "1.2-2" }}
											</div>
											<mat-icon class="tooltip-icon" [matMenuTriggerFor]="PAPlanTooltip" #PAPlanTrigger="matMenuTrigger"
												(mouseenter)="PAPlanTrigger.openMenu()">
												info
											</mat-icon>
											<mat-menu #PAPlanTooltip="matMenu" [overlapTrigger]="false" class="tooltip-popover">
												<span (mouseleave)="PAPlanTrigger.closeMenu()">
													{{ "addOn.PATooltip" | translate }}
												</span>
											</mat-menu>
										</div>
										<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
											{{ "addOn.coverage" | translate }}:
											<ul>
												<li>
													{{
													"addOn.PADesc"
													| translate
													: {
													sumInsured:
													selectedQuotation?.sumInsured
													| number : "1.2-2"
													}
													}}
												</li>
											</ul>
										</div>
									</ng-container>
									
									<!-- Unlimited Towing & PA Plan -->
									<ng-container *ngIf="addOn.customCode == 'UnlimitedTowing_PA'">
										<div fxLayout="row">
											<div class="title" fxFlex>
												{{ "addOn." + addOn?.customCode | translate }}
											</div>
											<div class="value">
												<span>RM</span>
												{{ getPrice(addOn, this.numberOfLltpSeats) | number : "1.2-2" }}
											</div>
											<mat-icon class="tooltip-icon" [matMenuTriggerFor]="PAPlanTooltip" #PAPlanTrigger="matMenuTrigger"
												(mouseenter)="PAPlanTrigger.openMenu()">
												info
											</mat-icon>
											<mat-menu #PAPlanTooltip="matMenu" [overlapTrigger]="false" class="tooltip-popover">
												<span (mouseleave)="PAPlanTrigger.closeMenu()">
													{{ "addOn." + addOn?.customCode + "Tooltip" | translate }}
												</span>
											</mat-menu>
										</div>
										<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
											{{ "addOn.coverage" | translate }}:
											<ul>
												<li>
													{{ "addOn." + addOn?.customCode + "Desc" | translate : { sumInsured: selectedQuotation?.sumInsured | number : "1.2-2" } }}
												</li>
											</ul>
										</div>
									</ng-container>

									<!-- IMotorbike PA Plan -->
									<ng-container *ngIf="addOn.customCode == 'IMOTORBIKE' && addOn.category == 'PA' ">
										<div fxLayout="row">
											<div class="title" fxFlex>
												{{ "addOn." + addOn?.code | translate }}
											</div>
											<div class="value">
												<span>RM</span>
												{{ getPrice(addOn, this.numberOfLltpSeats) | number : "1.2-2" }}
											</div>
											<mat-icon class="tooltip-icon" [matMenuTriggerFor]="PAPlanTooltip" #PAPlanTrigger="matMenuTrigger"
												(mouseenter)="PAPlanTrigger.openMenu()">
												info
											</mat-icon>
											<mat-menu #PAPlanTooltip="matMenu" [overlapTrigger]="false" class="tooltip-popover">
												<span (mouseleave)="PAPlanTrigger.closeMenu()">
													{{ "addOn.PATooltip" | translate }}
												</span>
											</mat-menu>
										</div>
										<div class="coverage-desc" *ngIf="isAddOnSelected(addOn)">
											{{ "addOn.coverage" | translate }}:
											<ul>
												<li>
													{{ "addOn." + addOn?.code + "Desc" | translate : { sumInsured: selectedQuotation?.sumInsured | number : "1.2-2" } }}
												</li>
											</ul>
										</div>
									</ng-container>
									
								</mat-checkbox>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'WOBC'">
						<ng-template
							#WOBC
							[ngTemplateOutlet]="WOBC"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
								*ngIf="addOn"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{ getPrice(addOn) | number : "1.2-2" }}
										</div>

										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="wobcTooltip"
											#wobcTrigger="matMenuTrigger"
											(mouseenter)="wobcTrigger.openMenu()"
										>
											info
										</mat-icon>
										<mat-menu
											#wobcTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="wobcTrigger.closeMenu()">
												{{ "addOn.WOBCTooltip" | translate }}
											</span>
										</mat-menu>
									</div>
									<div *ngIf="isAddOnSelected(addOn)">
										{{ "addOn.WOBCDesc" | translate }}
									</div>
								</mat-checkbox>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'CART'">
						<ng-template
							#CART
							[ngTemplateOutlet]="CART"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
								*ngIf="addOn"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div class="title" fxFlex>
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{ getPrice(addOn) | number : "1.2-2" }}
										</div>
									</div>
									<div *ngIf="isAddOnSelected(addOn)">
										{{ "addOn.CARTDesc" | translate }}
									</div>
								</mat-checkbox>

								<ng-container *ngIf="isAddOnSelected(addOn)">
									<div>
										<mat-form-field appearance="outline">
											<mat-label>{{ "common.days" | translate }}</mat-label>
											<mat-select formControlName="cartDays">
												<mat-option
													*ngFor="let item of cartDayList"
													[value]="item.codeValue"
												>
													{{ item.codeDesc + " " + ("common.day" | translate) }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>

									<div>
										<mat-form-field appearance="outline">
											<mat-label>{{
												"common.dailyCoverage" | translate
											}}</mat-label>
											<mat-select formControlName="cartDailyCoverage">
												<mat-option
													*ngFor="let item of cartDailyCoverageList"
													[value]="item.codeValue"
												>
													{{ item.codeDesc }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
								</ng-container>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'GCKT'">
						<ng-template
							#GCKT
							[ngTemplateOutlet]="GCKT"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
								*ngIf="addOn"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div fxFlex class="title">
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{
												getPrice(addOn, addOnFrmGroup.value.gckt)
													| number : "1.2-2"
											}}
										</div>
									</div>
								</mat-checkbox>

								<ng-container *ngIf="isAddOnSelected(addOn)">
									<div class="slider-desc pt-sm">
										{{ "addOn.coverage" | translate }} :
									</div>
									<app-range-slider
										[isMaxUnlimited]="true"
										[min]="this.minGCKTCoverage"
										[step]="50"
										[variantSmall]="true"
										formControlName="gckt"
										[minError]="
											'addOn.MinGCKTError'
												| translate
													: {
															amount:
																this.minGCKTCoverage
																| currency : 'RM' : 'symbol' : '1.2-2'
													  }
										"
									>
									</app-range-slider>
								</ng-container>
							</mat-card>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="'VA'">
						<ng-template
							#VA
							[ngTemplateOutlet]="VA"
							let-addOn="addOn"
							[ngTemplateOutletContext]="{ addOn: addOnList[0] }"
						>
							<mat-card
								class="addon-card"
								[class.selected]="isAddOnSelected(addOn)"
								*ngIf="addOn"
							>
								<mat-checkbox
									[value]="addOn"
									(change)="toggleAddOn($event)"
									[checked]="isAddOnSelected(addOn)"
								>
									<div fxLayout="row">
										<div fxFlex class="title">
											{{ "addOn." + addOn?.code | translate }}
										</div>
										<div class="value">
											<span>RM</span>
											{{
												getPrice(addOn, addOnFrmGroup.value.va)
													| number : "1.2-2"
											}}
										</div>
										<mat-icon
											class="tooltip-icon"
											[matMenuTriggerFor]="vaTooltip"
											#vaTrigger="matMenuTrigger"
											(mouseenter)="vaTrigger.openMenu()"
										>
											info
										</mat-icon>
										<mat-menu
											#vaTooltip="matMenu"
											[overlapTrigger]="false"
											class="tooltip-popover"
										>
											<span (mouseleave)="vaTrigger.closeMenu()">
												{{ "addOn.VATooltip" | translate }}
											</span>
										</mat-menu>
									</div>
								</mat-checkbox>

								<ng-container *ngIf="isAddOnSelected(addOn)">
									<div class="slider-desc pt-sm">
										{{ "addOn.coverage" | translate }} :
									</div>
									<app-range-slider
										[isMaxUnlimited]="true"
										[min]="this.minVACoverage"
										[step]="50"
										[variantSmall]="true"
										formControlName="va"
										[minError]="
											'addOn.MinVAError'
												| translate
													: {
															amount:
																this.minVACoverage
																| currency : 'RM' : 'symbol' : '1.2-2'
													  }
										"
									>
									</app-range-slider>
								</ng-container>
							</mat-card>
						</ng-template>
					</ng-container>
				</ng-container>
			</ng-template>
		</ng-container>
	</form>
</ng-template>

<ng-template #personalInfoFrom>
	<form [formGroup]="infoFrmGroup">
		<div class="section-container">
			<div class="title-sec">
				<div class="title-f">{{ "common.personalDetails" | translate }}</div>
				<div class="divider"></div>
			</div>

			<div class="content-wrapper">
				<ng-container *ngTemplateOutlet="personalDetail"> </ng-container>
			</div>

			<div class="form-field mt-sm">
				<mat-form-field appearance="outline" class="full-width">
					<mat-label>{{ getNameLabel() | translate }}</mat-label>
					<input matInput autocomplete="name" formControlName="name" />
					<mat-error>
						{{ getNameLabel() | translate }}
						{{ infoFrmGroup.controls?.name?.errors | inputError | translate }}
					</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="full-width mt-sm">
					<mat-label>{{ "common.occupation" | translate }}</mat-label>
					<input matInput autocomplete="off" formControlName="occupation" />
					<mat-error>
						{{ "common.occupation" | translate }}
						{{
							infoFrmGroup.controls?.occupation?.errors | inputError | translate
						}}
					</mat-error>
				</mat-form-field>
				<mat-form-field
					appearance="outline"
					class="landing-page-mobileno"
					class="full-width mt-sm"
				>
					<mat-label>{{ "common.mobileNo" | translate }}</mat-label>
					<ngx-mat-intl-tel-input
						[enableSearch]="true"
						[preferredCountries]="['my']"
						formControlName="mobileNo"
					>
					</ngx-mat-intl-tel-input>
					<mat-error>
						{{ "common.mobileNo" | translate }}
						{{
							infoFrmGroup.controls?.mobileNo?.errors | inputError | translate
						}}
					</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" class="full-width mt-sm">
					<mat-label>{{ "common.email" | translate }}</mat-label>
					<input matInput formControlName="email" autocomplete="email" />
					<mat-error
						style="display: block !important"
						[hidden]="!infoFrmGroup.controls.email?.errors?.email"
					>
						{{ "error.invalidEmail" | translate }}</mat-error
					>
					<mat-error
						>{{ "common.email" | translate }}
						{{
							infoFrmGroup.controls?.email?.errors | inputError | translate
						}}</mat-error
					>
				</mat-form-field>
			</div>
		</div>
		<div class="section-container">
			<div class="title-sec">
				<div class="title-f">{{ "common.residentialAddress" | translate }}</div>
				<div class="divider"></div>
			</div>
			<div class="form-field">
				<mat-form-field appearance="outline" class="full-width mt-sm">
					<mat-label>{{ "common.addressLineOne" | translate }}</mat-label>
					<input matInput formControlName="address" />
					<mat-error>
						{{ "common.addressLineOne" | translate }}
						{{
							infoFrmGroup.controls?.address?.errors | inputError | translate
						}}
					</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="full-width mt-sm">
					<mat-label>{{ "common.addressLineTwo" | translate }}</mat-label>
					<input matInput formControlName="address2" />
					<mat-error>
						{{ "common.addressLineTwo" | translate }}
						{{
							infoFrmGroup.controls?.address2?.errors | inputError | translate
						}}
					</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="full-width mt-sm">
					<mat-label>{{ "common.city" | translate }}</mat-label>
					<input matInput formControlName="city" />
					<mat-error>
						{{ "common.city" | translate }}
						{{ infoFrmGroup.controls?.city?.errors | inputError | translate }}
					</mat-error>
				</mat-form-field>
				<div class="full-width mt-sm">
					<mat-form-field appearance="outline" class="left">
						<mat-label>{{ "common.postcode" | translate }}</mat-label>
						<input matInput formControlName="postcode" />
					</mat-form-field>
					<mat-form-field appearance="outline" class="right">
						<mat-label>{{ "common.state" | translate }}</mat-label>
						<mat-select formControlName="state">
							<mat-option *ngFor="let item of stateList" [value]="item">{{
								item
							}}</mat-option>
						</mat-select>
						<mat-error>
							{{ "common.state" | translate }}
							{{
								infoFrmGroup.controls?.state?.errors | inputError | translate
							}}
						</mat-error>
					</mat-form-field>
				</div>

				<section
					*ngIf="
						addOnFrmGroup.value?.isIncludeRoadtax && !isIncludeDigitalRoadtax
					"
				>
					<mat-checkbox
						[checked]="isSameAddressChecked()"
						(change)="addressIsChecked($event)"
					>
						{{ "common.sameDeliveryAddress" | translate }}
					</mat-checkbox>
				</section>
			</div>
		</div>

		<div
			class="section-container"
			*ngIf="
				addOnFrmGroup.value?.isIncludeRoadtax &&
				!isIncludeDigitalRoadtax &&
				!isSameAddressCheck
			"
		>
			<div class="title-sec">
				<div class="title-f">{{ "common.deliveryAddress" | translate }}</div>
				<div class="divider"></div>
			</div>
			<div class="form-field">
				<mat-form-field appearance="outline" class="full-width mt-sm">
					<mat-label>{{ "common.addressLineOne" | translate }}</mat-label>
					<input matInput formControlName="deliveryAddress" />
					<mat-error>
						{{ "common.addressLineOne" | translate }}
						{{
							infoFrmGroup.controls?.deliveryAddress?.errors
								| inputError
								| translate
						}}
					</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="full-width mt-sm">
					<mat-label>{{ "common.addressLineTwo" | translate }}</mat-label>
					<input matInput formControlName="deliveryAddress2" />
					<mat-error>
						{{ "common.addressLineTwo" | translate }}
						{{
							infoFrmGroup.controls?.deliveryAddress2?.errors
								| inputError
								| translate
						}}
					</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="full-width mt-sm">
					<mat-label>{{ "common.city" | translate }}</mat-label>
					<input matInput formControlName="deliveryCity" />
					<mat-error>
						{{ "common.city" | translate }}
						{{
							infoFrmGroup.controls?.deliveryCity?.errors
								| inputError
								| translate
						}}
					</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="left">
					<mat-label>{{ "common.postcode" | translate }}</mat-label>
					<input matInput formControlName="deliveryPostcode" mask="00000" />
					<mat-error>
						{{ "common.postcode" | translate }}
						{{
							infoFrmGroup.controls?.deliveryPostcode?.errors
								| inputError
								| translate
						}}
					</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="right">
					<mat-label>{{ "common.state" | translate }}</mat-label>
					<mat-select formControlName="deliveryState">
						<mat-option *ngFor="let item of stateList" [value]="item">{{
							item
						}}</mat-option>
					</mat-select>
					<mat-error>
						{{ "common.state" | translate }}
						{{
							infoFrmGroup.controls?.deliveryState?.errors
								| inputError
								| translate
						}}
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		<div
			class="section-container"
		>
			<div class="title-sec">
				<div class="title-f">{{ "common.financingDetails" | translate }}</div>
				<div class="divider"></div>
			</div>

			<section>
				<mat-radio-group
					class="b2c-radio mh-sm"
					aria-label="Financing type"
					matInput
					formControlName="financingType"
				>
					<mat-radio-button color="primary" value="BankLoan">
						{{ "common.bankLoan" | translate }}
					</mat-radio-button>
					<mat-radio-button
						color="primary"
						value="Cash"
						style="margin-left: 24px !important"
					>
						{{ "common.cash" | translate }}
					</mat-radio-button>
				</mat-radio-group>
			</section>

			<mat-form-field
				appearance="outline"
				class="full-width"
				*ngIf="infoFrmGroup.controls['financingType'].value === 'BankLoan'"
			>
				<mat-label>Bank</mat-label>
				<input
					type="text"
					[placeholder]="'comparison.startTyping' | translate"
					aria-label="Bank"
					matInput
					formControlName="bank"
					[matAutocomplete]="auto"
				/>

				<mat-autocomplete #auto="matAutocomplete">
					<mat-option
						*ngFor="let item of filteredHirePurchase | async"
						[value]="item"
					>
						{{ item }}
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-field full-width">
				<mat-label> {{ "common.effectiveDate" | translate }}</mat-label>
				<input
					matInput
					(click)="picker.open()"
					[matDatepicker]="picker"
					formControlName="effectiveDate"
					readonly
				/>
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>
		</div>

		<div
			class="section-container"
			*ngIf="
				requestData?.businessType === 'TransferOwnership' || requestData?.businessType === 'NewRegister' ||
				(requestData?.businessType === 'Renewal' && hasSelectedCode('Flood')) ||
				(requestData?.businessType === 'Renewal' &&
					hasSelectedCode('Windshield'))
			"
		>
			<div class="title-sec">
				<div class="title-f">{{ "common.uploadDocuments" | translate }}</div>
				<div class="divider"></div>
			</div>
			<div class="upload-docs">
				<mat-card
					*ngIf="
						requestData?.businessType === 'TransferOwnership' || requestData?.businessType === 'NewRegister' ||
						(requestData?.businessType === 'Renewal' &&
							hasSelectedCode('Flood')) ||
						(requestData?.businessType === 'Renewal' &&
							hasSelectedCode('Windshield'))
					"
				>
					<div fxLayout="row" fxLayoutAlign="space-between">
						<div class="mr-sm">
							<div fxFlex>
								<img
									src="assets/icons/id-icon.png"
									alt="id"
									class="desktop-icon"
								/>
							</div>
							<div style="max-width: 300px">
								<div class="mdTitle-f">
									{{ "common.uploadMykad" | translate }}
								</div>
								<div>
									{{ "common.uploadMykadDesc" | translate }}
								</div>
								<div *ngIf="mykadOrPassport" class="mt-sm">
									<div
										*ngFor="let item of mykadOrPassport; let i = index"
										fxLayout="row"
										fxLayoutAlign=" center"
									>
										<div class="color-link">
											{{ item?.name | truncate : [10, "..."] }}
										</div>
										<div>
											<button
												mat-icon-button
												(click)="deleteFile('mykadOrPassport', i)"
											>
												<mat-icon>cancel</mat-icon>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div>
							<input
								type="file"
								accept="image/*, application/pdf"
								id="mykadOrPassport"
								multiple
								(change)="handleFileInput($event)"
								name="mykadOrPassport"
								style="display: none"
							/>
							<label for="mykadOrPassport" class="upload-label-btn">
								<mat-icon>add_circle</mat-icon>{{ "common.upload" | translate }}
							</label>
						</div>
					</div>
				</mat-card>
				<mat-card *ngIf="requestData?.businessType === 'TransferOwnership' || requestData?.businessType === 'NewRegister'">
					<div fxLayout="row" fxLayoutAlign="space-between">
						<div class="mr-sm">
							<div fxFlex>
								<img
									src="assets/icons/lou-icon.png"
									alt="lou"
									class="desktop-icon"
								/>
							</div>
							<div style="max-width: 300px">
								<div
									class="mdTitle-f"
									*ngIf="infoFrmGroup.value.financingType === 'BankLoan'"
								>
									{{ "common.uploadLOU" | translate }}
								</div>
								<div
									class="mdTitle-f"
									*ngIf="infoFrmGroup.value.financingType === 'Cash'"
								>
									{{ "common.uploadVSO" | translate }}
								</div>
								<div>{{ "common.uploadLOUVSODesc" | translate }}</div>
								<div *ngIf="letterOfUndertaking" class="mt-sm">
									<div
										*ngFor="let item of letterOfUndertaking; let i = index"
										fxLayout="row"
										fxLayoutAlign=" center"
									>
										<div class="color-link">
											{{ item?.name | truncate : [10, "..."] }}
										</div>
										<div>
											<button
												mat-icon-button
												(click)="deleteFile('letterOfUndertaking', i)"
											>
												<mat-icon>cancel</mat-icon>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div>
							<input
								type="file"
								accept="image/*, application/pdf"
								id="letterOfUndertaking"
								multiple
								(change)="handleFileInput($event)"
								name="letterOfUndertaking"
								style="display: none"
							/>
							<label for="letterOfUndertaking" class="upload-label-btn">
								<mat-icon class="">add_circle</mat-icon
								>{{ "common.upload" | translate }}
							</label>
						</div>
					</div>
				</mat-card>
				<mat-card
					*ngIf="
						(requestData?.businessType === 'TransferOwnership' && hasSelectedCode('Flood')) || 
						(requestData?.businessType === 'TransferOwnership' && hasSelectedCode('Windshield')) || 
						requestData?.businessType === 'NewRegister' ||
						(requestData?.businessType === 'Renewal' &&
							hasSelectedCode('Flood')) ||
						(requestData?.businessType === 'Renewal' &&
							hasSelectedCode('Windshield'))
					"
				>
					<div fxLayout="row" fxLayoutAlign="space-between">
						<div class="mr-sm">
							<div fxFlex>
								<img
									src="assets/icons/car-icon.png"
									alt="lou"
									class="desktop-icon"
								/>
							</div>
							<div style="max-width: 300px">
								<div class="mdTitle-f">
									{{ "common.uploadVehiclePhoto" | translate }}
								</div>
								<div>{{ "common.uploadVehiclePhotoDesc" | translate }}</div>
								<div *ngIf="vehiclePhoto" class="mt-sm">
									<div
										*ngFor="let item of vehiclePhoto; let i = index"
										fxLayout="row"
										fxLayoutAlign=" center"
									>
										<div class="color-link">
											{{ item?.name | truncate : [10, "..."] }}
										</div>
										<div>
											<button
												mat-icon-button
												(click)="deleteFile('vehiclePhoto', i)"
											>
												<mat-icon>cancel</mat-icon>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div>
							<input
								type="file"
								accept="image/*, application/pdf"
								id="vehiclePhoto"
								multiple
								(change)="handleFileInput($event)"
								name="vehiclePhoto"
								style="display: none"
							/>
							<label for="vehiclePhoto" class="upload-label-btn">
								<mat-icon class="">add_circle</mat-icon
								>{{ "common.upload" | translate }}
							</label>
						</div>
					</div>
				</mat-card>
				<mat-card
					*ngIf="isVehicleTypeMotorcycle">
					<div fxLayout="row" fxLayoutAlign="space-between">
						<div class="mr-sm">
							<div fxFlex>
								<img src="assets/image/two-wheeler.png" alt="lou" class="desktop-icon" />
							</div>
							<div style="max-width: 300px">
								<div class="mdTitle-f">
									{{ "common.uploadMotorcyclePhoto" | translate }}
								</div>
								<div>{{ "common.uploadMotorcyclePhotoDesc" | translate }}</div>
								<div *ngIf="vehiclePhoto" class="mt-sm">
									<div *ngFor="let item of vehiclePhoto; let i = index" fxLayout="row" fxLayoutAlign=" center">
										<div class="color-link">
											{{ item?.name | truncate : [10, "..."] }}
										</div>
										<div>
											<button mat-icon-button (click)="deleteFile('vehiclePhoto', i)">
												<mat-icon>cancel</mat-icon>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div>
							<input type="file" accept="image/*, application/pdf" id="vehiclePhoto" multiple
								(change)="handleFileInput($event)" name="vehiclePhoto" style="display: none" />
							<label for="vehiclePhoto" class="upload-label-btn">
								<mat-icon class="">add_circle</mat-icon>{{ "common.upload" | translate }}
							</label>
						</div>
					</div>
				</mat-card>
				<mat-card *ngIf="hasSelectedCode('Flood')">
					<div fxLayout="row" fxLayoutAlign="space-between">
						<div class="mr-sm">
							<div fxFlex>
								<img
									src="assets/icons/car-icon.png"
									alt=""
									class="desktop-icon"
								/>
							</div>
							<div style="max-width: 300px">
								<div class="mdTitle-f">
									{{ "common.uploadVehiclePhoto" | translate }}
								</div>
								<div>
									{{ "common.uploadVehicleInteriorPhotoDesc" | translate }}
								</div>
								<div *ngIf="vehicleInteriorPhoto" class="mt-sm">
									<div
										*ngFor="let item of vehicleInteriorPhoto; let i = index"
										fxLayout="row"
										fxLayoutAlign=" center"
									>
										<div class="color-link">
											{{ item?.name | truncate : [10, "..."] }}
										</div>
										<div>
											<button
												mat-icon-button
												(click)="deleteFile('vehicleInteriorPhoto', i)"
											>
												<mat-icon>cancel</mat-icon>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div>
							<input
								type="file"
								accept="image/*, application/pdf"
								id="vehicleInteriorPhoto"
								multiple
								(change)="handleFileInput($event)"
								name="vehicleInteriorPhoto"
								style="display: none"
							/>
							<label for="vehicleInteriorPhoto" class="upload-label-btn">
								<mat-icon class="">add_circle</mat-icon
								>{{ "common.upload" | translate }}
							</label>
						</div>
					</div>
				</mat-card>
				<mat-card *ngIf="hasSelectedCode('Flood')">
					<div fxLayout="row" fxLayoutAlign="space-between">
						<div class="mr-sm">
							<div fxFlex>
								<img
									src="assets/icons/car-icon.png"
									alt=""
									class="desktop-icon"
								/>
							</div>
							<div style="max-width: 300px">
								<div class="mdTitle-f">
									{{ "common.uploadVehicleVideo" | translate }}
								</div>
								<div>{{ "common.uploadVehicleVideoDesc" | translate }}</div>
								<div *ngIf="vehicleVideo" class="mt-sm">
									<div
										*ngFor="let item of vehicleVideo; let i = index"
										fxLayout="row"
										fxLayoutAlign=" center"
									>
										<div class="color-link">
											{{ item?.name | truncate : [10, "..."] }}
										</div>
										<div>
											<button
												mat-icon-button
												(click)="deleteFile('vehicleVideo', i)"
											>
												<mat-icon>cancel</mat-icon>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div>
							<input
								type="file"
								accept="video/mp4, video/flv, video/mov"
								id="vehicleVideo"
								multiple
								(change)="handleVideoFileInput($event)"
								name="vehicleVideo"
								style="display: none"
							/>
							<label for="vehicleVideo" class="upload-label-btn">
								<mat-icon class="">add_circle</mat-icon
								>{{ "common.upload" | translate }}
							</label>
						</div>
					</div>
				</mat-card>
			</div>
		</div>
	</form>
</ng-template>
